export default {
  nav: {
    home: 'Beranda',
    howItWorks: 'Cara Kerja',
    forArchitects: 'Untuk Arsitek',
    signIn: 'Masuk',
    signUp: 'Daftar',
    untukArsitek: 'Untuk Arsitek',
    untukKlien: 'Untuk Klien',
    masuk: 'Masuk',
    mulaiProyek: 'Mulai Proyek Gratis',
    dasbor: 'Dasbor',
    keluar: 'Keluar'
  },
  landing: {
    eyebrow: '1.4k+ Arsitek Berlisensi IAI',
    hero: {
      title: 'Wujudkan Desain Impian, Tanpa Ribet',
      subline:
        'Bandingkan penawaran arsitek terbaik, kelola proyek dengan cermat, dan bangun impian Anda bersama rumantra.',
      cta: 'Mulai Proyek Gratis',
      learnMore: 'Pelajari cara kerja',
      microcopy: 'Gratis untuk klien · Tanpa biaya pendaftaran'
    },
    trust: {
      rating: '4.9/5',
      desc: 'dari 1.200+ ulasan pengguna'
    },
    jelajahi: {
      trending: 'Daftar Proyek',
      searchPlaceholder: 'Cari proyek, arsitek, atau gaya desain...',
      filterAll: 'Semua',
      filterHunian: 'Hunian',
      filterKomersil: 'Komersial',
      filterIndustrial: 'Industrial',
      filterLainnya: 'Lainnya',
      emptyState: 'Belum ada proyek yang tersedia.',
      addDesign: 'Tambah Desain'
    },
    starters: {
      eyebrow: 'Mulai Di Sini',
      title: 'Kamu mau bangun apa?',
      subline: 'Pilih titik awal, dan kami bantu susun brief-nya dari situ.'
    },
    howItWorks: {
      eyebrow: 'Cara Kerja',
      step1Title: 'Posting Brief Proyek',
      step1Desc:
        'Ceritakan kebutuhan Anda — luas, anggaran, gaya desain. AI kami akan membantu merumuskan brief profesional.',
      step2Title: 'Terima & Bandingkan Penawaran',
      step2Desc:
        'Arsitek berlisensi IAI mengajukan penawaran. Bandingkan harga, timeline, dan portofolio secara berdampingan.',
      step3Title: 'Bangun dengan Tenang',
      step3Desc:
        'Arsitek terpilih mulai bekerja. Dana cair per milestone — proyek terjamin selesai sesuai rencana.'
    },
    why: {
      label: 'Dirancang untuk ketenangan pikiran Anda',
      card1Title: 'Arsitek terverifikasi IAI',
      card1Desc:
        'Hanya arsitek dengan lisensi resmi dan portofolio terverifikasi yang bisa bergabung.',
      card2Title: 'Harga transparan',
      card2Desc:
        'Bandingkan harga dari berbagai studio secara apel-ke-apel tanpa biaya tersembunyi.',
      card3Title: 'Pembayaran aman',
      card3Desc: 'Dana Anda aman di escrow rumantra sampai tahap pengerjaan disetujui.',
      card4Title: 'Komunikasi terpusat',
      card4Desc: 'Semua revisi, dokumen, dan chat tersimpan rapi dalam satu dashboard proyek.',
      card5Title: 'Beragam keahlian',
      card5Desc: 'Dari rumah minimalis hingga stadion olahraga, tersedia spesialis untuk semuanya.',
      card6Title: 'Seluruh Indonesia',
      card6Desc: 'Temukan talenta lokal di kota Anda atau arsitek ternama di ibu kota.'
    },
    cta: {
      title: 'Siap Mulai Proyek Impian Anda?',
      subline:
        'Bergabunglah dengan ribuan klien yang membangun dengan percaya diri bersama rumantra.',
      primary: 'Mulai Proyek Gratis',
      secondary: 'Daftar sebagai Arsitek'
    },
    v2: {
      nav: {
        howItWorks: 'Cara kerja',
        findArchitect: 'Cari arsitek',
        estimateCost: 'Estimasi biaya',
        login: 'Masuk',
        cta: 'Buat brief proyek'
      },
      hero: {
        title: 'Semua kebutuhan arsitektur Anda, dalam satu tempat',
        subline:
          'Kirim satu brief, dapatkan proposal desain, dan kelola proyek Anda dalam satu platform.',
        cta: 'Buat brief proyek',
        yourProject: 'Proyek Anda',
        offerPrefix: 'Penawaran #'
      },
      joinArchitect: {
        question: 'Anda arsitek/desainer?',
        cta: 'Gabung di sini'
      },
      caraKerja: {
        title: 'Cara kerja rumantra',
        cta: 'Mulai brief gratis',
        step1Title: 'Ceritakan proyek Anda',
        step1Desc: 'Isi brief singkat soal jenis, lokasi, luas, dan budget. Gratis, ±5 menit.',
        step2Title: 'Terima penawaran arsitek',
        step2Desc: 'Harga, jadwal, dan portofolio dari arsitek yang terverifikasi.',
        step3Title: 'Bandingkan dan pilih',
        step3Desc: 'Lihat penawaran berdampingan, lalu pilih arsitek yang paling cocok.',
        step4Title: 'Kelola bersama di dashboard',
        step4Desc: 'Pantau progres, diskusi, dan setujui tiap tahap bersama arsitek Anda.'
      },
      tipeProyek: {
        title: 'Seluruh kebutuhan desain Anda, ada di rumantra',
        viewAll: 'Lihat semua',
        hunian: {
          title: 'Hunian',
          desc: 'Wujudkan hunian yang nyaman, fungsional, dan estetik'
        },
        komersil: {
          title: 'Komersil',
          desc: 'Selaraskan desain dengan tujuan bisnis Anda'
        },
        industrial: {
          title: 'Industrial',
          desc: 'Desain dan denah efisien untuk mendukung produksi dan operasi Anda'
        },
        lainnya: {
          title: 'Lainnya',
          desc: 'Dari rumah ibadah hingga sekolah, semuanya ada di sini'
        }
      },
      estimasi: {
        title: 'Cari budget ideal Anda',
        continueCta: 'Lanjutkan ke brief proyek',
        jenisLabel: 'Jenis pekerjaan',
        workBaru: 'Bangun baru',
        workRenovasi: 'Renovasi',
        budgetLabelBaru: 'Perkiraan budget pembangunan',
        budgetLabelRenovasi: 'Perkiraan budget renovasi',
        budgetHint:
          'Perkiraan biaya pembangunan saja, di luar harga tanah. Isi kolom kedua bila Anda punya kisaran.',
        sampai: 'sampai',
        minPlaceholder: 'Rp',
        maxPlaceholder: 'Rp (opsional)',
        otherNeeds: 'Punya kebutuhan lain, seperti desain interior atau perluasan bangunan?',
        otherNeedsCta: 'Ceritakan lewat brief proyek',
        feeEyebrow: 'Perkiraan biaya desain',
        feeSubtitle1: 'Untuk desain arsitektur sampai gambar kerja.',
        feeSubtitle2: 'Tidak termasuk biaya pembangunan.',
        calcToggle: 'Asumsi perhitungan',
        estimateNote: 'Estimasi awal. Penawaran akhir mengikuti kebutuhan dan lingkup proyek.',
        fillBudgetNotice: 'Isi perkiraan budget untuk melihat estimasi.',
        invalidRangeNotice: 'Angka kedua sebaiknya lebih besar dari angka pertama.',
        calcBudgetLabel: 'Budget pembangunan',
        calcScopeLabel: 'Lingkup layanan',
        calcScopeValue: 'Desain arsitektur sampai gambar kerja',
        calcCategoryLabel: 'Kategori bangunan',
        renovationAdjustment: 'penyesuaian renovasi',
        calcMethodLabel: 'Metode',
        calcMethodValue: 'Tabel imbalan jasa Pedoman IAI edisi 2007'
      },
      mitra: {
        title: 'Arsitek dan desainer terbaik, ada di rumantra',
        subtitle: 'Mitra kami telah melewati proses screening, hanya yang terbaik yang ada disini',
        awardTitle: 'Arsitek Peraih Penghargaan',
        awardDesc: 'Karya mereka diakui di ajang arsitektur nasional maupun internasional.',
        firmTitle: 'Biro Arsitek Ternama',
        firmDesc: 'Firma mapan dengan rekam jejak panjang dan portofolio proyek yang terbukti.',
        risingTitle: 'Desainer Muda Berbakat',
        risingDesc: 'Talenta baru dengan ide segar dan pendekatan desain yang berani.'
      },
      ruangProyek: {
        title: 'Satu tempat untuk mengelola proyek Anda.',
        projectName: 'Kosan Premium 12 Kamar',
        projectOwner: 'Aryadiza Gunawan',
        tabDiskusi: 'Diskusi',
        tabKontrak: 'Kontrak',
        tabFile: 'File desain',
        stageLabel: 'Tahapan pekerjaan',
        stage1: 'Konsep desain',
        stage2: 'Pengembangan desain',
        stage3: 'Gambar kerja',
        stage4: 'Penyerahan akhir',
        reviewLabel: 'Menunggu tinjauan Anda',
        item1Title: 'Denah lantai 1',
        item1Meta: 'Dikirim 2 hari lalu · revisi ke-1 dari 3',
        viewBtn: 'Lihat gambar',
        reviseBtn: 'Ajukan revisi',
        item2Title: 'Tampak depan',
        item2Meta: 'Disetujui 5 hari lalu',
        benefit1Title: 'Tahu sudah sampai mana',
        benefit1Desc:
          'Lihat tahapan pekerjaan, hasil yang perlu diserahkan, dan desain yang menunggu tinjauan Anda.',
        benefit2Title: 'Sampaikan revisi dengan jelas',
        benefit2Desc:
          'Tinjau hasil desain dan ajukan revisi dalam ruang proyek yang sama. Lanjutkan diskusi lewat chat atau panggilan.',
        benefit3Title: 'Kontrak dan gambar mudah ditemukan',
        benefit3Desc:
          'Buat kontrak bersama arsitek dan simpan hasil gambar dalam satu tempat yang bisa Anda akses kembali.'
      },
      pembayaran: {
        title: 'Pembayaran mengikuti progres yang Anda setujui',
        step1Title: 'Brief dan kontrak disepakati',
        step1Desc:
          'Lingkup kerja, jumlah revisi, dan tenggat ditulis di kontrak sebelum pembayaran pertama.',
        step2Title: 'Dana ditampung sebelum dicairkan',
        step2Desc:
          'Pembayaran Anda ditampung lebih dulu, tidak langsung diteruskan seluruhnya ke arsitek.',
        step3Title: 'Pembayaran dicairkan per tahap',
        step3Desc:
          'Anda meninjau hasil di ruang proyek, mengajukan revisi bila perlu, lalu menyetujui tahap tersebut.',
        step4Title: 'Bantuan saat terjadi perselisihan',
        step4Desc:
          'Tim rumantra membantu menengahi dengan acuan kontrak dan rekam jejak pekerjaan di ruang proyek.'
      },
      faq: {
        title: 'FAQ',
        items: [
          {
            q: 'Apa saja yang gratis di rumantra?',
            a: 'Membuat brief proyek, menerima penawaran, dan membandingkan arsitek tidak dipungut biaya. Yang Anda bayar adalah jasa desain arsitek, sesuai kesepakatan di kontrak.'
          },
          {
            q: 'Apakah saya wajib memilih penawaran yang masuk?',
            a: 'Tidak. Brief proyek bisa Anda revisi dan sebar ulang, atau tutup tanpa biaya, kalau belum ada penawaran yang cocok.'
          },
          {
            q: 'Apa bedanya biaya desain dan biaya pembangunan?',
            a: 'Biaya desain adalah jasa arsitek: konsep, gambar kerja, dan revisi sesuai kontrak. Biaya pembangunan mencakup konstruksi, material, dan perizinan, dan tidak termasuk dalam estimasi di halaman ini.'
          },
          {
            q: 'Berapa lama sampai penawaran pertama masuk?',
            a: 'rumantra masih dalam tahap beta, jadi kami belum punya angka rata-rata yang bisa dipertanggungjawabkan. Anda akan diberi kabar setiap kali ada penawaran baru di ruang proyek.'
          },
          {
            q: 'Siapa pemilik hak atas gambar desainnya?',
            a: 'Ketentuan hak pakai gambar diatur dalam kontrak yang Anda sepakati dengan arsitek sebelum pekerjaan dimulai, dan bisa Anda baca kembali kapan saja di ruang proyek.'
          },
          {
            q: 'Bagaimana kalau hasil tidak sesuai brief?',
            a: 'Ajukan revisi dengan merujuk poin brief yang belum terpenuhi, sesuai jatah revisi di kontrak.'
          },
          {
            q: 'Bagaimana kalau pekerjaan terlambat?',
            a: 'Tenggat setiap tahap tercatat di ruang proyek dan bisa Anda angkat ke tim rumantra.'
          },
          {
            q: 'Bagaimana kalau saya tidak sepakat dengan arsitek?',
            a: 'Perselisihan ditengahi dengan acuan kontrak, riwayat diskusi, dan hasil yang sudah diserahkan.'
          },
          {
            q: 'Bagaimana kalau proyek dibatalkan?',
            a: 'Penanganan dana yang belum dicairkan mengikuti ketentuan pembatalan di kontrak Anda.'
          }
        ]
      },
      penutup: {
        title: 'Mulai dari rencana Anda',
        desc1:
          'Ceritakan kebutuhan, lokasi, dan perkiraan luas bangunan untuk membantu arsitek menyusun penawaran yang sesuai.',
        desc2:
          'Setelah memilih arsitek, kelola kontrak, progres, revisi, dan hasil desain bersama dalam ruang proyek Anda.',
        cta: 'Buat brief proyek',
        freeNote:
          'Gratis membuat brief dan menerima penawaran. Biaya desain disepakati dengan arsitek sebelum pekerjaan dimulai.',
        architectCta: 'Anda arsitek? Bergabung sebagai mitra rumantra'
      }
    }
  },
  mulaiProyek: {
    title: 'Cari desain impian Kamu',
    subline:
      'Jelajahi desain yang rumantra bisa akomodir, atau isi formulir singkat kalau Kamu sudah tahu apa yang dicari.',
    toggleToForm: 'Isi formulir manual',
    toggleToBrowse: 'Kembali jelajahi desain',
    form: {
      heading: 'Ceritakan brief proyek Kamu',
      projectType: 'Kategori',
      projectScope: 'Lingkup Proyek',
      location: 'Lokasi',
      locationPlaceholder: 'cth. Jakarta Selatan',
      lotSize: 'Luas Lahan (m²)',
      lotSizePlaceholder: 'cth. 200',
      budget: 'Budget Desain (Fee Arsitek)',
      budgetPlaceholder: 'cth. 150.000.000',
      budgetHint:
        'Panduan IAI: tentukan fee desain yang wajar sesuai skala dan kompleksitas proyek Kamu.',
      description: 'Apa yang Kamu bayangkan?',
      descriptionPlaceholder:
        'Jumlah ruangan, preferensi gaya, target waktu — apa pun akan membantu.',
      title: 'Judul Proyek',
      titlePlaceholder: 'cth. Rumah Keluarga Modern di Bandung',
      phone: 'Nomor Telepon',
      phonePlaceholder: 'cth. +62 812 3456 7890',
      phoneInvalid: 'Masukkan nomor telepon yang valid (10-16 digit).',
      startDate: 'Perkiraan Mulai',
      startImmediately: 'Secepatnya',
      startSpecificDate: 'Pada tanggal tertentu',
      submit: 'Lanjutkan',
      submitAuthed: 'Lanjut ke formulir lengkap',
      submitting: 'Menyimpan...',
      submitError: 'Brief Kamu gagal disimpan. Silakan coba lagi.',
      microcopy: 'Belum perlu akun — Kamu bisa daftar tepat sebelum posting.'
    }
  },
  navbar: {
    switchRole: 'Ganti Peran',
    architectMode: 'Mode Arsitek',
    clientMode: 'Mode Klien',
    activateArchitect: 'Aktifkan sebagai Arsitek',
    activateClient: 'Aktifkan sebagai Klien',
    profile: 'Profil Saya',
    portfolios: 'Portofolio Saya',
    language: 'Bahasa',
    logout: 'Keluar'
  },
  hero: {
    title1: 'Dapatkan desain',
    title2: 'Arsitektur terbaik',
    title3: 'Melalui Perbandingan!',
    subtitle:
      'Memberdayakan pemilik rumah dengan pemilihan arsitek berbasis data. Bandingkan desain, anggaran, dan lacak proyek Anda dengan presisi.',
    cta: 'Mari Memulai'
  },
  solutions: {
    personalArch: 'Arsitektur Personal',
    projectBrief: 'Brief Proyek',
    findArchitect: 'Cari Arsitek',
    budgetTool: 'Alat Anggaran',
    priceAnalysis: 'Analisis Harga',
    digitalBlueprint: 'Blueprint Digital',
    trackMilestones: 'Lacak Milestone',
    aiInspiration: 'Inspirasi AI'
  },
  visualization: {
    title: 'Didesain oleh ahli, Dibangun oleh Anda.',
    trustedBy: 'Dipercayai Oleh'
  },
  premium: {
    label: 'rumantra Premium',
    title: 'Solusi Profesional untuk Setiap Blueprint',
    cta: 'Solusi Lengkap Kami',
    features: {
      transparent: {
        title: 'Biaya dan Jadwal Transparan',
        desc: 'Setiap biaya diuraikan di muka. Tanpa biaya tersembunyi, tanpa perpanjangan mendadak. Anda tahu persis apa yang Anda bayar.'
      },
      ai: {
        title: 'Brief Arsitektur Berbasis AI',
        desc: 'Asisten AI kami membantu Anda merumuskan visi Anda ke dalam brief profesional yang mudah dieksekusi oleh arsitek.'
      },
      analysis: {
        title: 'Analisis Harga Pragmatis',
        desc: 'Bandingkan penawaran menggunakan analisis berbasis data kami untuk memastikan Anda mendapatkan nilai terbaik untuk investasi Anda.'
      },
      billing: {
        title: 'Sistem Penagihan Pro-rata',
        desc: 'Dana hanya dicairkan saat milestone tercapai, memastikan proyek Anda tetap sesuai jalur dan anggaran.'
      }
    }
  },
  gallery: {
    title: 'Inspirasi Tanpa Batas',
    subtitle:
      'Temukan keajaiban arsitektur modern yang dikurasi dari para profesional terbaik kami.'
  },
  cta: {
    title: 'Siap menyewa Arsitek Ahli Anda?',
    subtitle:
      'Bergabunglah dengan ribuan pemilik rumah yang membangun impian mereka melalui platform rumantra.',
    startNow: 'Mulai Sekarang',
    learnMore: 'Pelajari Lebih Lanjut',
    hirePro: 'Sewa Pro',
    verified: 'Profesional Terverifikasi',
    secure: 'Pembayaran Aman',
    searchNow: 'Cari Sekarang'
  },
  footer: {
    description:
      'Platform marketplace arsitektur premium Indonesia. Menghubungkan visi Anda dengan para profesional terbaik.',
    platform: 'Platform',
    company: 'Perusahaan',
    legal: 'Legal',
    howItWorks: 'Cara Kerja',
    forArchitects: 'Untuk Arsitek',
    signUpIn: 'Daftar / Masuk',
    pricing: 'Harga',
    about: 'Tentang Kami',
    careers: 'Karir',
    blog: 'Blog',
    contact: 'Kontak',
    terms: 'Syarat & Ketentuan',
    privacy: 'Kebijakan Privasi',
    rights: 'All rights reserved'
  },
  auth: {
    signup: {
      registerTitle: 'Buat akun baru',
      registerSubtitle: 'Gratis. Hanya butuh satu menit.',
      registerAs: 'Daftar sebagai',
      roleClient: 'Klien',
      roleArchitect: 'Arsitek',
      orEmail: 'atau daftar dengan email',
      title: 'Bergabung dengan rumantra',
      subtitle: 'Mulai perjalanan arsitektur Anda hari ini',
      firstName: 'Nama Depan',
      lastName: 'Nama Belakang',
      email: 'Email',
      password: 'Kata Sandi',
      confirmPassword: 'Konfirmasi Kata Sandi',
      agreeTerms: 'Saya setuju dengan Syarat & Ketentuan dan Kebijakan Privasi',
      legal: {
        prefix: 'Saya telah membaca dan menyetujui',
        termsLabel: 'Syarat & Ketentuan',
        and: 'dan',
        privacyLabel: 'Kebijakan Privasi',
        suffix: 'rumantra.',
        loading: 'Memuat dokumen...',
        staleTerms: 'Syarat & Ketentuan telah diperbarui, silakan tinjau dan setujui kembali.',
        noticePrefix: 'Dengan melanjutkan, Anda menyetujui',
        noticeSuffix: 'kami.'
      },
      createAccount: 'Buat Akun',
      alreadyHave: 'Sudah punya akun?',
      signInHere: 'Masuk di sini',
      orContinueWith: 'Atau lanjutkan dengan',
      roleSelection: {
        title: 'Saya ingin',
        subtitle: 'Pilih cara Anda menggunakan rumantra',
        client: {
          title: 'Menyewa Arsitek',
          desc: 'Posting proyek, bandingkan penawaran, dan kelola desain arsitektur Anda'
        },
        architect: {
          title: 'Menawarkan Layanan',
          desc: 'Tampilkan portofolio, ajukan penawaran, dan kembangkan praktik Anda'
        },
        continue: 'Lanjutkan sebagai'
      },
      success: {
        title: 'Akun Berhasil Dibuat!',
        subtitle: 'Selamat datang di rumantra',
        message:
          'Email verifikasi telah dikirim ke email Anda. Silakan cek inbox atau folder spam Anda.',
        redirecting: 'Mengarahkan Anda...'
      },
      errors: {
        passwordMismatch: 'Kata sandi tidak cocok',
        weakPassword: 'Kata sandi harus minimal 8 karakter',
        invalidEmail: 'Email tidak valid',
        required: 'Bidang ini wajib diisi',
        agreeTermsRequired: 'Anda harus menyetujui syarat dan ketentuan'
      }
    },
    login: {
      title: 'Selamat Datang Kembali',
      subtitle: 'Masuk ke akun rumantra Anda',
      email: 'Email',
      password: 'Kata Sandi',
      rememberMe: 'Ingat saya',
      forgotPassword: 'Lupa kata sandi?',
      signIn: 'Masuk',
      noAccount: 'Belum punya akun?',
      signUpHere: 'Daftar di sini',
      orContinueWith: 'Atau lanjutkan dengan',
      panelTitle: 'Satu akun untuk seluruh proyek Anda.',
      panelSubtitle: 'Klien dan arsitek masuk dari pintu yang sama.',
      perks: [
        'Lanjutkan brief dan proyek kapan saja',
        'Bandingkan penawaran dari arsitek terverifikasi',
        'Kelola kontrak, progres, dan pembayaran di satu tempat'
      ],
      tabLogin: 'Masuk',
      tabRegister: 'Daftar',
      emailPlaceholder: 'cth. budi@email.com',
      passwordPlaceholder: 'Kata sandi Anda',
      googleCta: 'Lanjutkan dengan Google',
      linkedinCta: 'Lanjutkan dengan LinkedIn',
      orEmail: 'atau dengan email',
      verified: 'Email berhasil diverifikasi. Silakan masuk untuk melanjutkan.',
      errors: {
        invalidCredentials: 'Email atau kata sandi salah',
        required: 'Bidang ini wajib diisi'
      }
    },
    verifyEmail: {
      verifying: 'Memverifikasi email Anda...',
      pleaseWait: 'Mohon tunggu sebentar',
      success: 'Email Terverifikasi!',
      successMessage:
        'Email Anda telah berhasil diverifikasi. Sekarang Anda dapat masuk ke akun Anda.',
      continueToLogin: 'Lanjut ke Masuk',
      failed: 'Verifikasi Gagal',
      failedMessage: 'Link verifikasi tidak valid atau telah kadaluarsa.',
      emailLabel: 'Email',
      resend: 'Kirim Ulang Email Verifikasi',
      resendSuccess: 'Email verifikasi terkirim! Silakan cek inbox Anda.',
      backToLogin: 'Kembali ke Masuk'
    },
    callback: {
      processing: 'Sedang masuk...',
      pleaseWait: 'Mohon tunggu sementara kami menyelesaikan login Anda',
      success: 'Login Berhasil!',
      redirecting: 'Anda telah berhasil masuk.',
      takingYou: 'Mengarahkan ke dashboard Anda...',
      error: 'Login Gagal',
      genericError: 'Terjadi kesalahan saat login. Silakan coba lagi.',
      returnToLogin: 'Kembali ke Login'
    }
  },
  notFound: {
    title: 'Halaman Tidak Ditemukan',
    message:
      'Halaman yang Anda cari mungkin telah dihapus, namanya diubah, atau sementara tidak tersedia.',
    backHome: 'Kembali ke Beranda',
    goBack: 'Kembali'
  },
  profile: {
    title: 'Profil Saya',
    editProfile: 'Edit Profil',
    saveProfile: 'Simpan Profil',
    cancel: 'Batal',
    done: 'Selesai',
    autosave: {
      saving: 'Menyimpan...',
      savedToast: 'Perubahan tersimpan — profil {percent}% lengkap',
      error: 'Gagal menyimpan — periksa koneksi Anda'
    },
    viewMode: {
      practiceName: 'Nama Praktik',
      city: 'Kota',
      experience: 'Tahun Pengalaman',
      philosophy: 'Filosofi Desain',
      expertise: 'Bidang Keahlian',
      ktpNum: 'Nomor KTP',
      ktpVerified: 'KTP Terverifikasi',
      npwp: 'NPWP',
      npwpVerified: 'NPWP Terverifikasi',
      verified: 'Terverifikasi',
      notVerified: 'Belum Terverifikasi',
      category: 'Jenis Praktik',
      address: 'Alamat',
      education: 'Pendidikan'
    },
    form: {
      practiceName: 'Nama Praktik',
      practiceNamePlaceholder: 'contoh: Studio Archipelago',
      city: 'Kota',
      cityPlaceholder: 'contoh: Jakarta',
      experience: 'Tahun Pengalaman',
      experiencePlaceholder: 'Pilih rentang pengalaman',
      philosophy: 'Filosofi Desain',
      philosophyPlaceholder: 'Jelaskan filosofi desain Anda...',
      expertise: 'Bidang Keahlian',
      expertisePlaceholder: 'Pilih minimal satu bidang',
      enhanceWithAI: 'Tingkatkan dengan AI',
      ktpNum: 'Nomor KTP',
      ktpNumPlaceholder: 'Masukkan nomor KTP 16 digit',
      npwp: 'NPWP',
      npwpPlaceholder: 'Masukkan NPWP 15-16 digit',
      fullnameKtp: 'Nama Lengkap (sesuai KTP)',
      fullnameKtpPlaceholder: 'contoh: Budi Santoso',
      phoneNum: 'Nomor HP',
      phoneNumPlaceholder: 'contoh: 08123456789',
      category: 'Jenis Praktik',
      categoryFreelance: 'Freelance',
      categoryCompany: 'Perusahaan',
      fullAddress: 'Alamat Lengkap',
      fullAddressPlaceholder: 'Jalan, gedung, unit, dll.',
      province: 'Provinsi',
      provincePlaceholder: 'Pilih provinsi',
      cityDropdownPlaceholder: 'Pilih kota',
      photo: 'Foto Profil',
      education: 'Pendidikan',
      educationAdd: 'Tambah pendidikan',
      educationRemove: 'Hapus',
      educationLevel: 'Jenjang Pendidikan',
      educationLevelPlaceholder: 'Pilih jenjang pendidikan',
      educationUniversity: 'Universitas',
      educationUniversityPlaceholder: 'Pilih universitas',
      educationFieldOfStudy: 'Program Studi',
      educationFieldOfStudyPlaceholder: 'contoh: Arsitektur',
      educationGraduationYear: 'Tahun Lulus',
      educationGraduationYearPlaceholder: 'contoh: 2018'
    },
    validation: {
      nameMinLength: 'Nama praktik minimal 2 karakter',
      cityMinLength: 'Kota minimal 2 karakter',
      ktpNumInvalid: 'Nomor KTP harus tepat 16 digit',
      npwpInvalid: 'NPWP harus 15 atau 16 digit',
      phoneNumInvalid: 'Nomor HP harus 8 hingga 16 digit'
    },
    toast: {
      updateSuccess: 'Profil berhasil diperbarui',
      updateError: 'Gagal memperbarui profil. Silakan coba lagi.',
      loadError: 'Gagal memuat profil. Silakan coba lagi.',
      photoUpdateSuccess: 'Foto profil berhasil diperbarui',
      photoUpdateError: 'Gagal mengunggah foto. Silakan coba lagi.'
    },
    completion: {
      title: 'Kelengkapan Profil',
      cta: 'Lengkapi profil Anda',
      basicInfo: 'Info Dasar',
      businessLocation: 'Bisnis & Lokasi',
      identityDocs: 'Dokumen Identitas',
      portfolio: 'Portofolio'
    }
  },
  settings: {
    changePassword: {
      title: 'Ubah Kata Sandi',
      currentPassword: 'Kata Sandi Saat Ini',
      currentPasswordPlaceholder: 'Masukkan kata sandi saat ini',
      newPassword: 'Kata Sandi Baru',
      newPasswordPlaceholder: 'Masukkan kata sandi baru',
      confirmPassword: 'Konfirmasi Kata Sandi Baru',
      confirmPasswordPlaceholder: 'Masukkan ulang kata sandi baru',
      submit: 'Perbarui Kata Sandi',
      policyHint: 'Minimal 8 karakter, dengan angka, huruf besar, huruf kecil, dan karakter khusus',
      mismatchError: 'Kata sandi baru dan konfirmasi tidak cocok',
      success: 'Kata sandi berhasil diubah',
      error: 'Gagal mengubah kata sandi. Silakan coba lagi.'
    }
  },
  portfolio: {
    title: 'Portofolio Saya',
    addPortfolio: 'Tambah Portofolio',
    editPortfolio: 'Edit Portofolio',
    deletePortfolio: 'Hapus Portofolio',
    emptyState: {
      title: 'Belum ada portofolio',
      description: 'Buat portofolio pertama Anda untuk menampilkan karya',
      cta: 'Buat Portofolio'
    },
    card: {
      photos: 'foto',
      edit: 'Edit',
      delete: 'Hapus',
      madeWithRumantra: 'Dibuat dengan rumantra'
    },
    modal: {
      createTitle: 'Buat Portofolio',
      editTitle: 'Edit Portofolio',
      save: 'Simpan Portofolio',
      cancel: 'Batal',
      close: 'Tutup',
      unsavedChanges: 'Anda memiliki perubahan yang belum disimpan. Yakin ingin menutup?',
      saving: 'Menyimpan...'
    },
    form: {
      title: 'Judul Proyek',
      titlePlaceholder: 'contoh: Rumah Tropis Jakarta',
      description: 'Deskripsi',
      descriptionPlaceholder: 'Jelaskan proyek ini...',
      projectDate: 'Tanggal Proyek',
      projectDatePlaceholder: 'Pilih tanggal',
      location: 'Lokasi',
      locationPlaceholder: 'contoh: Jakarta, Indonesia',
      projectType: 'Kategori Bangunan (IAI)',
      projectTypePlaceholder:
        'Buka sebuah kategori dan pilih satu tipe bangunan yang sesuai dengan proyek ini.',
      isBuilt: 'Proyek ini sudah dibangun',
      images: 'Gambar Proyek',
      lockedHint: 'Diambil dari data proyek asli dan tidak dapat diubah'
    },
    imageManager: {
      uploadZone: 'Klik atau seret gambar ke sini',
      maxImages: 'Maksimal 8 gambar',
      maxSize: 'Maksimal 10MB per gambar',
      currentCount: 'gambar terunggah',
      addMore: 'Tambah gambar',
      deleteImage: 'Hapus gambar',
      uploading: 'Mengunggah...'
    },
    validation: {
      titleRequired: 'Judul proyek wajib diisi',
      projectDateRequired: 'Tanggal proyek wajib diisi',
      projectTypeRequired: 'Tipe proyek wajib diisi',
      imagesRequired: 'Minimal satu gambar wajib diunggah',
      maxImagesReached: 'Maksimal 8 gambar diperbolehkan',
      fileTooLarge: 'Gambar harus kurang dari 10MB',
      invalidFileType: 'Hanya file gambar yang diperbolehkan'
    },
    toast: {
      createSuccess: 'Portofolio berhasil dibuat',
      updateSuccess: 'Portofolio berhasil diperbarui',
      deleteSuccess: 'Portofolio berhasil dihapus',
      createError: 'Gagal membuat portofolio. Silakan coba lagi.',
      updateError: 'Gagal memperbarui portofolio. Silakan coba lagi.',
      deleteError: 'Gagal menghapus portofolio. Silakan coba lagi.',
      imageUploadSuccess: 'Gambar berhasil diunggah',
      imageUploadError: 'Gagal mengunggah gambar. Silakan coba lagi.',
      imageDeleteSuccess: 'Gambar berhasil dihapus',
      imageDeleteError: 'Gagal menghapus gambar. Silakan coba lagi.'
    },
    deleteConfirm: {
      title: 'Hapus Portofolio',
      message: 'Yakin ingin menghapus portofolio ini? Tindakan ini tidak dapat dibatalkan.',
      confirm: 'Hapus',
      cancel: 'Batal'
    }
  },
  bid: {
    aboutStudio: 'Tentang studio Anda',
    aboutStudioPlaceholder:
      'Ceritakan kepada klien tentang keahlian, pengalaman, dan pendekatan studio Anda...',
    conceptStatement: 'Pernyataan Konsep',
    conceptStatementRequired: 'wajib diisi',
    conceptStatementPlaceholder:
      'Jelaskan konsep desain Anda, fitur utama, dan bagaimana Anda akan memenuhi kebutuhan klien...',
    conceptStatementHelp:
      'Jelaskan rencana desain, konsep, dan pendekatan Anda untuk proyek ini (maksimal 200 kata)',
    attachPortfolios: 'Lampirkan Portofolio yang Relevan',
    attachPortfoliosHelp: 'Pilih portofolio yang menunjukkan pengalaman relevan Anda',
    wordCount: '{count}/200 kata',
    wordCountExceeded: 'Pernyataan konsep tidak boleh melebihi 200 kata',
    phasesTotalMismatch:
      'Total fase pembayaran harus sama dengan jumlah penawaran. Harap sesuaikan fase Anda.'
  },
  bidCreate: {
    title: 'Kirim Penawaran',
    updateTitle: 'Perbarui Penawaran',
    subtitle: 'Tunjukkan keahlian Anda dan menangkan proyek ini',
    updateSubtitle: 'Lanjutkan mengedit draft penawaran Anda',
    projectSummary: 'Ringkasan Proyek',
    project: 'Proyek',
    location: 'Lokasi',
    designBudget: 'Anggaran Desain',
    buildArea: 'Luas Bangunan',
    buildingType: 'Tipe Bangunan',
    deliverables: 'Deliverables',
    bidAmount: 'Nilai Penawaran (IDR)',
    timeline: 'Timeline yang Diusulkan (hari)',
    paymentPhases: 'Fase Pembayaran',
    paymentPhasesHelp:
      'Tentukan fase pembayaran. Total semua fase harus sama dengan nilai penawaran.',
    submitBtn: 'Kirim Penawaran',
    cancelBtn: 'Batal',
    submitting: 'Mengirim...',
    backToOpportunities: 'Kembali ke Peluang',
    identityIncompleteTitle: 'Verifikasi identitas diperlukan untuk mengirim',
    identityIncompleteDesc:
      'Lengkapi KTP, NPWP, nama lengkap sesuai KTP, dan nomor HP sebelum mengajukan penawaran. Anda masih dapat menyimpan draft.',
    identityIncompleteAction: 'Lengkapi Profil',
    identityIncompleteError:
      'Harap lengkapi informasi identitas (KTP, NPWP, nama lengkap sesuai KTP, dan nomor HP) di halaman Profil sebelum mengirim penawaran. Draft Anda tetap tersimpan.',
    identityIncompleteMissingLabel: 'Yang belum lengkap:',
    identityIncompleteDismiss: 'Nanti Saja',
    savingDraft: 'Menyimpan draft...',
    completeProfileLink: 'Lengkapi Profil →',
    studioPhilosophyHelp:
      'Diisi otomatis dari Filosofi Desain di profil Anda — silakan sesuaikan untuk proyek ini.',
    aspectRatioHint:
      'Rasio aspek yang disarankan: 16:9 agar tampil optimal pada perbandingan penawaran',
    referenceImages: 'Foto Referensi dari Klien',
    facadeDescriptionPlaceholder:
      'Tambahkan konteks tentang foto fasad ini (material, gaya, kondisi lokasi)...',
    interiorDescriptionPlaceholder: 'Tambahkan konteks tentang foto interior ini...',
    massingDescriptionPlaceholder: 'Tambahkan konteks tentang foto massing ini...',
    zoningDescriptionPlaceholder: 'Tambahkan konteks tentang foto zonasi ini...',
    deliverableCategories: {
      preliminaryPlanning: 'Perencanaan Awal',
      architecturalDesign: 'Desain Arsitektur',
      technicalDesign: 'Desain Teknis',
      interiorLandscape: 'Interior dan Landscape',
      calculationEstimation: 'Perhitungan & Estimasi',
      other: 'Lainnya'
    },
    deliverableItems: {
      SITE_ANALYSIS: 'Analisis Tapak',
      ZONING_STUDY: 'Analisis Zonasi & Regulasi',
      SITE_BLOCK_PLAN: 'Site Plan & Block Plan',
      FLOOR_PLAN: 'Denah',
      ELEVATION_SECTION: 'Tampak & Potongan',
      DETAIL_DRAWINGS:
        'Rencana & Detail (Atap, Plafon, Lantai, Kamar Mandi, Kusen, Pintu & Jendela, dll.)',
      RENDER_3D_EXTERIOR: 'Render Gambar 3D Eksterior',
      RENDER_3D_INTERIOR: 'Render Gambar 3D Interior',
      RENDER_3D_VIDEO: 'Render Video 3D Walkthrough/Animation',
      MATERIAL_FINISHING_SPEC: 'Spesifikasi Material dan Finishing',
      STRUCTURAL_DRAWINGS: 'Gambar Struktur',
      MECHANICAL_DRAWINGS: 'Gambar Mechanical',
      ELECTRICAL_DRAWINGS: 'Gambar Electrical',
      PLUMBING_DRAWINGS: 'Gambar Plumbing',
      FIRE_PROTECTION_DRAWINGS: 'Gambar Proteksi Kebakaran',
      STRUCTURAL_CALCULATION: 'Perhitungan Struktur',
      MEP_CALCULATION: 'Perhitungan Mekanikal, Elektrikal & Plumbing (MEP)',
      INTERIOR_DESIGN: 'Desain Interior',
      LANDSCAPE_DESIGN: 'Desain Landscape',
      COST_ESTIMATION: 'Estimasi Biaya',
      ARCHITECTURAL_DRAWINGS: 'Gambar Arsitektur',
      DESIGN_VISUALIZATION_3D: 'Visualisasi 3D & Presentasi Desain',
      MEP_DRAWINGS: 'Gambar Mekanikal, Elektrikal & Plumbing (MEP)'
    },
    deliverableDescriptions: {
      SITE_ANALYSIS: [
        'Arsitek mempelajari lahan Anda sebelum merancang apa pun, misalnya arah matahari dan angin, jalur akses, dan pepohonan yang ada. Dengan tahapan ini, bangunan Anda dirancang menyesuaikan kondisi lahan yang sebenarnya.'
      ],
      ZONING_STUDY: [
        'Pengecekan terhadap aturan tata ruang pemerintah daerah, seperti apakah lahan Anda boleh dibangun, jumlah lantai maksimal yang diizinkan, dan teknis lain seperti jarak minimum antara muka bangunan dan jalan, batas lahan terbangun, batas total luas lantai, dan minimum lahan hijau pada lahan Anda. Tahap ini melindungi Anda dari risiko izin ditolak atau bangunan yang harus dibongkar di kemudian hari.'
      ],
      SITE_BLOCK_PLAN: [
        'Site Plan menunjukkan posisi bangunan Anda di dalam lahan, misalnya letak carport, taman, dan pagar.',
        'Block Plan menunjukkan posisi lahan Anda dalam suatu kawasan, umumnya digunakan untuk proyek townhouse.'
      ],
      FLOOR_PLAN: [
        'Gambar tata letak dan dimensi seluruh ruangan dalam bangunan yang dilihat dari atas.'
      ],
      ELEVATION_SECTION: [
        'Tampak menunjukkan wujud bangunan dari empat arah beserta materialnya.',
        'Potongan menunjukkan bangunan yang “diiris” secara vertikal untuk memperlihatkan detail seperti tinggi plafon, ketebalan lantai, dan kemiringan atap.'
      ],
      DETAIL_DRAWINGS: [
        'Gambar rinci mengenai dimensi komponen bangunan Anda. Berguna untuk tahap konstruksi dan menjadi referensi ketika Anda membeli atau mendesain komponen seperti pintu, jendela, kusen, dan lain-lain.'
      ],
      RENDER_3D_EXTERIOR: [
        'Visualisasi tampilan luar bangunan dalam bentuk gambar realistis sebelum bangunan benar-benar berdiri.'
      ],
      RENDER_3D_INTERIOR: [
        'Visualisasi suasana ruang dalam bangunan, seperti pencahayaan, ukuran ruangan, warna, dan penataan furnitur.'
      ],
      RENDER_3D_VIDEO: ['Simulasi video yang membawa Anda menyusuri rancangan bangunan.'],
      MATERIAL_FINISHING_SPEC: [
        'Daftar rinci mengenai jenis, merek, dan kualitas material yang digunakan pada setiap bagian bangunan. Dokumen ini umumnya menjadi acuan tertulis untuk memastikan kesesuaian kualitas material yang terpasang.'
      ],
      STRUCTURAL_DRAWINGS: [
        'Gambar teknis untuk komponen seperti pondasi, kolom, dan balok, beserta ukuran dan kekuatannya. Tahap ini krusial untuk Anda melanjutkan desain ke tahap konstruksi.'
      ],
      MECHANICAL_DRAWINGS: [
        'Gambar teknis untuk mengatur sistem tata udara, seperti AC dan ventilasi, di seluruh bagian bangunan.'
      ],
      ELECTRICAL_DRAWINGS: [
        'Gambar teknis untuk mengatur jalur kelistrikan, termasuk titik lampu, saklar, dan stop kontak di setiap ruangan dalam bangunan.'
      ],
      PLUMBING_DRAWINGS: [
        'Gambar teknis untuk mengatur jalur perpipaan air bersih, air kotor, dan air hujan.'
      ],
      FIRE_PROTECTION_DRAWINGS: [
        'Gambar teknis untuk mengatur sistem deteksi dan pemadam kebakaran, seperti sprinkler dan alarm. Umumnya diperlukan untuk bangunan komersial atau bertingkat.'
      ],
      STRUCTURAL_CALCULATION: [
        'Perhitungan teknis yang membuktikan bahwa kekuatan struktur bangunan telah sesuai standar keamanan. Dokumen ini diperlukan untuk pengurusan izin bangunan (PBG) dan menjadi jaminan bahwa struktur dirancang dengan perhitungan yang tepat, bukan perkiraan.'
      ],
      MEP_CALCULATION: [
        'Perhitungan kebutuhan daya listrik, kapasitas pompa air, dan sistem pendukung lainnya sesuai kebutuhan bangunan.'
      ],
      INTERIOR_DESIGN: [
        'Perancangan lanjutan setelah denah, yang menentukan pemilihan warna, furnitur, dan pencahayaan di dalam ruangan. Tahap ini menghadirkan karakter dan kenyamanan pada rumah Anda, tidak sekadar ruang kosong yang telah selesai dibangun.'
      ],
      LANDSCAPE_DESIGN: [
        'Perancangan mendetail area terbuka seperti taman dan jalur pejalan kaki yang meliputi jumlah, tipe, dan ukuran komponen seperti pohon, bebatuan, dan pencahayaan.'
      ],
      COST_ESTIMATION: [
        'Perkiraan total biaya yang dibutuhkan untuk membangun desain bangunan Anda.'
      ]
    },
    selectAll: 'Pilih Semua',
    deselectAll: 'Batalkan Semua'
  },
  identityDocs: {
    title: 'Verifikasi Identitas',
    subtitle: 'Diperlukan sebelum mengajukan penawaran. Anda dapat melewati ini untuk sekarang.',
    notice:
      'KTP, NPWP, dan nama lengkap Anda akan diverifikasi secara manual oleh tim rumantra. Nomor HP memerlukan verifikasi OTP via WhatsApp, yang dapat dilakukan di halaman Profil.',
    fullnameKtp: 'Nama Lengkap (sesuai KTP)',
    fullnameKtpPlaceholder: 'mis. Budi Santoso',
    ktpNum: 'Nomor KTP',
    ktpNumPlaceholder: '16 digit nomor KTP',
    ktpNumError: 'Nomor KTP harus tepat 16 digit',
    npwp: 'NPWP',
    npwpPlaceholder: '15–16 digit nomor NPWP',
    npwpError: 'NPWP harus 15 atau 16 digit',
    phoneNum: 'Nomor HP (WhatsApp)',
    phoneNumPlaceholder: 'mis. 08123456789',
    phoneNumHint: 'Verifikasi OTP via WhatsApp dilakukan di halaman Profil.',
    back: 'Kembali',
    skip: 'Lewati untuk sekarang',
    save: 'Simpan & Lanjutkan',
    saving: 'Menyimpan...',
    sendOtp: 'Kirim OTP via WhatsApp',
    otpSent: 'OTP telah dikirim ke WhatsApp Anda',
    otpCode: 'Masukkan Kode OTP',
    otpCodePlaceholder: '6 digit OTP',
    verify: 'Verifikasi',
    verifying: 'Memverifikasi...',
    verified: 'Terverifikasi',
    notVerified: 'Belum terverifikasi',
    verifyPhone: 'Verifikasi HP',
    otpError: 'OTP tidak valid atau sudah kadaluarsa. Silakan coba lagi.',
    resendOtp: 'Kirim Ulang OTP',
    phoneVerifiedSuccess: 'Nomor HP berhasil diverifikasi.'
  },
  clientDashboard: {
    title: 'Dashboard Klien',
    subtitle: 'Selamat datang di ruang kerja Anda',
    myProjects: 'Proyek Saya',
    seeAll: 'Lihat semua',
    noSubmittedProjects:
      'Belum ada proyek yang dikirim. Brief yang sudah Anda kirim akan muncul di sini.',
    myProjectsSubtitle: 'Kelola dan lacak proyek arsitektur Anda',
    newProject: 'Proyek Baru',
    noProjectsYet: 'Belum ada proyek',
    noProjectsMessage: 'Buat proyek pertama Anda untuk mulai mencari arsitek',
    createProject: 'Buat Proyek',
    bidSingular: 'Penawaran',
    bidPlural: 'Penawaran',
    backToProjects: 'Kembali ke Proyek',
    receivedBids: 'Penawaran yang Diterima',
    noBidsYet: 'Belum ada penawaran',
    noBidsMessage: 'Arsitek akan mengirimkan penawaran mereka segera',
    acceptBid: 'Terima Penawaran',
    acceptConfirm: 'Apakah Anda yakin ingin menerima penawaran ini?',
    lotSize: 'Luas Lahan',
    designBudget: 'Anggaran Desain',
    description: 'Deskripsi',
    deliverables: 'Deliverables yang Diperlukan',
    proposedCost: 'Biaya yang Diajukan',
    duration: 'Durasi',
    days: 'hari',
    status: 'Status',
    winner: 'Pemenang',
    biddingDeadline: 'Batas Waktu Bidding',
    deadline: 'Batas Waktu',
    bidAcceptedTitle: 'Penawaran Diterima — Menyelesaikan Syarat',
    bidAcceptedDesc: 'Tinjau syarat penawaran terpilih dan konfirmasi sebelum pekerjaan dimulai.',
    continueToFinalization: 'Lanjutkan ke Finalisasi',
    projectRejectedTitle: 'Proyek Ditolak',
    projectRejectedFallback:
      'Proyek ini ditolak. Silakan hubungi support untuk informasi lebih lanjut.',
    draftBannerTitle: 'Proyek ini masih berupa draf',
    draftBannerDesc:
      'Lengkapi pengisian dan kirimkan untuk ditinjau sebelum arsitek dapat mengajukan penawaran.',
    continueEditing: 'Lanjutkan Mengedit',
    comparativeAnalysis: 'Analisis Perbandingan',
    subjectA: 'Subjek A',
    subjectB: 'Subjek B',
    emptyCompareSlot: 'Kosong — pilih dari daftar',
    compareHint: 'Pilih penawaran dari daftar di bawah untuk memulai analisis perbandingan',
    bidRegistry: 'Daftar Penawaran',
    welcome: 'Selamat datang',
    manageProjects: 'Kelola proyek arsitektur Anda',
    newProjectBtn: 'PROYEK BARU',
    activeProjects: 'Proyek Aktif',
    totalBids: 'Total Penawaran',
    budgetUsed: 'Anggaran Terpakai',
    activeVentures: 'PROYEK AKTIF',
    viewAll: 'LIHAT SEMUA →',
    recentActivity: 'Aktivitas Terkini',
    noActivityYet: 'Belum ada aktivitas terkini',
    curatedSelection: 'Pilihan Terkurasi',
    findArchitect: 'Temukan Arsitek Anda',
    browseStudiosDesc: 'Jelajahi jaringan studio arsitektur kami yang siap untuk proyek Anda.',
    browseStudios: 'JELAJAHI STUDIO →'
  },
  projectCreate: {
    titleNew: 'Pasang Proyek Baru',
    titleDraft: 'Lanjutkan Draf Proyek',
    subtitle: 'Tentukan kebutuhan Anda untuk menemukan arsitek yang tepat',
    phoneRequiredBody:
      'Tambahkan nomor telepon agar arsitek dan tim kami dapat menghubungi Anda. Nomor ini akan disimpan di profil Anda.',
    phoneLabel: 'Nomor Telepon',
    phoneRequiredError:
      'Nomor telepon wajib diisi agar arsitek dan tim kami dapat menghubungi Anda.',
    phoneInvalidError: 'Masukkan nomor telepon yang valid.',
    designBudgetRangeError: 'Harga maksimum harus sama dengan atau lebih besar dari harga minimum.',
    part: 'Bagian',
    partImages: 'Gambar Proyek',
    partGeneral: 'Tentang Proyek Anda',
    partDeliverables: 'Deliverable',
    stepOf: 'Langkah {step} dari {total}',
    nextStepHint: 'Langkah berikutnya: deliverable & gambar proyek',
    next: 'Lanjutkan',
    back: 'Kembali',
    saveDraftAndExit: 'Simpan Draft & Keluar',
    selectCategoryFirst: 'Pilih kategori terlebih dahulu',
    deliverablesHint:
      'Pilih dokumen dan gambar yang Anda butuhkan dari arsitek. Arahkan kursor ke ikon informasi untuk melihat penjelasan tiap deliverable.',
    partBudget: 'Anggaran',
    partStartDate: 'Perkiraan Tanggal Mulai',
    partDeadline: 'Batas Waktu Penawaran',
    projectTitle: 'Judul Proyek',
    projectTitlePlaceholder: 'cth. Kost Modern di Depok',
    addressSearch: 'Alamat Lokasi Proyek',
    addressSearchPlaceholder: 'Cari alamat atau nama tempat...',
    addressSearchHint:
      'Mulai ketik lalu pilih lokasi Anda dari saran — ini mengisi alamat, kota, dan provinsi sekaligus menaruh penanda di peta.',
    addressSearchUnavailable: 'Pencarian alamat tidak tersedia. Silakan ketik alamat lengkap.',
    addressResolved: 'Terdeteksi:',
    pinLocation: 'Tandai Lokasi di Peta',
    pinLocationHint:
      'Klik peta untuk menaruh penanda, lalu geser tepat ke lokasi proyek. Arsitek memakai ini untuk membaca kontur, vegetasi, dan lingkungan sekitar sebelum menyusun penawaran.',
    pinLocationNotSet: 'Penanda belum diatur — arsitek hanya akan melihat areanya.',
    pinLocationClear: 'Hapus penanda',
    pinLocationUnavailable:
      'Peta sedang tidak tersedia. Anda tetap dapat memposting proyek dengan alamat di atas.',
    lotSize: 'Luas Lahan (m²)',
    lotSizePlaceholder: 'cth. 200',
    lotSizeHint: 'Luas total tanah/kavling.',
    buildArea: 'Luas Bangunan (m²)',
    buildAreaPlaceholder: 'cth. 120',
    buildAreaHint: 'Total luas lantai yang akan dibangun. Kosongkan bila ingin ditentukan arsitek.',
    buildAreaExceedsLotError:
      'Luas bangunan tidak boleh melebihi luas lahan untuk bangunan satu lantai.',
    numberOfFloors: 'Jumlah Lantai',
    numberOfFloorsPlaceholder: 'cth. 2',
    detailedRequirements: 'Kebutuhan Detail',
    detailedRequirementsPlaceholder:
      'Jelaskan jumlah ruangan, preferensi gaya (cth. Industrial, Tropis), dan batasan waktu...',
    designBudgetLabel: 'Fee Desain (Fee Arsitek)',
    designBudgetDescription: 'Ini adalah acuan utama arsitek untuk mengajukan penawaran',
    designBudgetMinLabel: 'Harga Minimum',
    designBudgetMaxLabel: 'Harga Maksimum',
    designBudgetHint:
      '<strong>Panduan IAI:</strong> Menurut Ikatan Arsitek Indonesia (IAI), fee desain umumnya menyesuaikan skala dan kompleksitas proyek. Tentukan rentang harga yang wajar untuk proyek Anda.',
    startDateHint: 'Beri tahu arsitek kapan Anda memperkirakan konstruksi dimulai.',
    biddingClosesOn: 'Penawaran Ditutup Pada',
    biddingDeadlineHint:
      'Tentukan tanggal penutupan penawaran arsitek. Setelah tanggal ini proyek ditutup otomatis dan penawaran yang tidak dipilih akan dikembalikan.',
    biddingDaysLeft: 'hari waktu penawaran',
    biddingDayLeft: 'hari waktu penawaran',
    saving: 'Menyimpan...',
    cancel: 'Batal',
    posting: 'Memasang...',
    postProject: 'Pasang Proyek',
    budgetPlaceholder: 'cth. 2.000.000.000',
    dropImages: 'Letakkan gambar di sini atau klik untuk mengunggah',
    imagesHint:
      'Unggah foto, mood board, atau gambar inspirasi untuk proyek Anda (maks. 10 gambar)',
    imageFormats: 'PNG, JPG, GIF maks. 5MB per file',
    maxLabel: 'maks.',
    maxFilesLabel: 'file',
    maxFilesReached: 'Maksimal {max} gambar dapat diunggah di sini.',
    projectScope: 'Lingkup Proyek',
    category: 'Kategori',
    subCategory: 'Sub-Kategori',
    selectScope: 'Pilih lingkup proyek',
    selectCategory: 'Pilih kategori',
    selectSubCategory: 'Pilih sub-kategori',
    immediately: 'Segera',
    immediatelyDesc: 'Proyek dapat dimulai segera setelah arsitek dipilih',
    specificDate: 'Pada Tanggal Tertentu',
    specificDateDesc: 'Anda punya target tanggal mulai',
    targetStartDate: 'Target Tanggal Mulai'
  },
  clientProfile: {
    title: 'Profil Saya',
    subtitle: 'Kelola informasi pribadi Anda',
    editProfile: 'Edit Profil',
    saveProfile: 'Simpan Perubahan',
    cancel: 'Batal',
    viewMode: {
      title: 'Informasi Profil',
      firstName: 'Nama Depan',
      lastName: 'Nama Belakang',
      fullName: 'Nama Lengkap',
      email: 'Alamat Email',
      phoneNumber: 'Nomor Telepon',
      ktpNumber: 'Nomor KTP',
      verified: 'Terverifikasi',
      city: 'Kota',
      companyName: 'Nama Perusahaan',
      projectStats: 'Statistik Proyek',
      projectsMatched: 'Proyek Dicocokkan',
      projectsCompleted: 'Proyek Selesai'
    },
    form: {
      firstName: 'Nama Depan',
      firstNamePlaceholder: 'Masukkan nama depan Anda',
      lastName: 'Nama Belakang',
      lastNamePlaceholder: 'Masukkan nama belakang Anda',
      phoneNumber: 'Nomor Telepon',
      phoneNumberPlaceholder: '+62 812 3456 7890',
      ktpNumber: 'Nomor KTP',
      ktpNumberPlaceholder: '1234567890123456',
      ktpReadOnly: 'Field ini tidak dapat diedit setelah verifikasi',
      nameReadOnly: 'Nama tidak dapat diedit setelah verifikasi KTP',
      locked: 'Terkunci',
      verified: 'Terverifikasi',
      city: 'Kota',
      cityPlaceholder: 'contoh: Jakarta, Bandung, Surabaya',
      companyName: 'Nama Perusahaan (Opsional)',
      companyNamePlaceholder: 'Perusahaan atau organisasi Anda',
      readOnly: 'Field ini tidak dapat diedit'
    },
    validation: {
      firstNameRequired: 'Nama depan wajib diisi',
      lastNameRequired: 'Nama belakang wajib diisi',
      phoneRequired: 'Nomor telepon wajib diisi',
      phoneInvalid: 'Masukkan nomor telepon yang valid',
      ktpInvalid: 'Nomor KTP harus 16 digit angka',
      cityRequired: 'Kota wajib diisi'
    },
    toast: {
      loadError: 'Gagal memuat profil',
      updateSuccess: 'Profil berhasil diperbarui!',
      updateError: 'Gagal memperbarui profil'
    }
  },
  common: {
    saving: 'Menyimpan...',
    notSet: 'Belum diatur',
    backToDashboard: 'Kembali ke Dashboard',
    back: 'Kembali',
    optional: 'opsional',
    dismiss: 'Tutup',
    moreInfo: 'Informasi selengkapnya'
  },
  tokenPurchase: {
    modal: {
      title: 'Beli Token Bid',
      currentQuota: 'Sisa Token Anda',
      tier: 'Tier Langganan',
      pricePerToken: 'Harga per Token',
      quantity: 'Jumlah Token',
      total: 'Total Pembayaran',
      confirm: 'Lanjut ke Pembayaran',
      cancel: 'Batal',
      redirectInfo:
        'Anda akan diarahkan ke halaman pembayaran Xendit untuk menyelesaikan transaksi',
      quantityRange: 'Pilih 1-50 token'
    },
    error: {
      default: 'Gagal memproses pembelian token',
      fetchPricing: 'Gagal mengambil informasi harga',
      invalidQuantity: 'Jumlah token harus antara 1-50',
      purchaseFailed: 'Gagal membuat permintaan pembayaran'
    }
  },
  contractAgreement: {
    eyebrowSigned: 'Perjanjian yang ditandatangani',
    eyebrow: 'Sebelum Anda konfirmasi',
    title: 'Perjanjian Kontrak',
    workspaceLede: 'Perjanjian yang ditandatangani kedua pihak sebelum pekerjaan dimulai.',
    openButton: 'Baca & Setujui Perjanjian Kontrak',
    viewButton: 'Lihat',
    closeLabel: 'Tutup',
    cancel: 'Batal',
    prerequisiteHint: 'Anda perlu membaca dan menyetujui kontrak sebelum dapat mengonfirmasi.',
    scrollHint: 'Gulir sampai akhir kontrak untuk menandatanganinya.',
    signatureLabel: 'Ketik nama lengkap Anda untuk menandatangani',
    signaturePlaceholder: 'Nama lengkap Anda',
    signatureHint: 'Ketik nama Anda persis seperti pada akun Anda: {name}',
    nameMismatch: 'Nama harus sama dengan nama pada akun Anda: {name}',
    agreeButton: 'Saya setuju & tanda tangan',
    agreeing: 'Menandatangani...',
    accepted: 'Kontrak disetujui',
    clientSignature: 'Klien',
    architectSignature: 'Arsitek',
    notSigned: 'Belum ditandatangani',
    loadError: 'Kontrak tidak dapat dimuat. Silakan coba lagi.',
    acceptError: 'Tanda tangan Anda tidak dapat disimpan. Silakan coba lagi.'
  },
  finalization: {
    loading: 'Memuat finalisasi...',
    noAcceptedBid: 'Tidak ada bid yang diterima untuk proyek ini',
    loadError: 'Gagal memuat data negosiasi',
    tryAgain: 'Coba lagi',
    badge: 'Finalisasi',
    biddingDeadline: 'Batas Bid',
    bothConfirmed: 'Kedua pihak telah mengkonfirmasi — proyek kini berjalan!',
    yourBid: 'Penawaran Anda',
    proposedPrice: 'Harga yang Diajukan',
    timeline: 'Durasi',
    days: 'hari',
    deliverables: 'Deliverable',
    revisionCommitments: 'Komitmen Revisi',
    siteAnalysis: 'Analisis Tapak',
    designPhases: 'Fase Desain',
    permitsAndDocs: 'Izin & Dokumen',
    specialized: 'Layanan Khusus',
    construction: 'Konstruksi',
    rev: 'rev',
    designConcept: 'Konsep Desain',
    portfolioRefs: 'Referensi Portofolio',
    discussion: 'Diskusi',
    discussionSubtitle: 'Diskusikan ketentuan proyek dengan klien',
    chatUnavailable: 'Chat belum tersedia',
    confirmPrompt: 'Tinjau ketentuan yang disepakati dan konfirmasi untuk melanjutkan proyek ini.',
    confirmButton: 'Konfirmasi & Mulai Proyek',
    confirming: 'Mengkonfirmasi...',
    confirmed: 'Anda telah mengkonfirmasi',
    awaitingClient: 'Menunggu konfirmasi klien...',
    clientAlsoConfirmed: 'Klien juga telah mengkonfirmasi.',
    clientConfirmedStatus: 'Klien telah mengkonfirmasi bagian mereka.',
    awaitingClientStatus: 'Menunggu klien untuk mengkonfirmasi...',
    confirmDialog: 'Konfirmasi ketentuan dan lanjutkan proyek ini?',
    confirmError: 'Gagal mengkonfirmasi ketentuan',
    confirmModalEyebrow: 'Konfirmasi & Lanjutkan',
    modalCancel: 'Batal'
  },
  notifications: {
    title: 'Notifikasi',
    markAllRead: 'Tandai semua sudah dibaca',
    viewAll: 'Lihat semua notifikasi',
    loading: 'Memuat notifikasi...',
    loadError: 'Gagal memuat notifikasi',
    retry: 'Coba lagi',
    filterAll: 'Semua',
    filterUnread: 'Belum dibaca',
    subtitleUnread: '{n} belum dibaca dari {total} notifikasi.',
    subtitleAllRead: 'Semua notifikasi sudah dibaca.',
    subtitleEmpty: 'Pembaruan proyek dan tawaran Anda.',
    allReadTitle: 'Semua sudah dibaca',
    allReadMessage: 'Notifikasi baru akan muncul di sini.',
    loadMore: 'Muat lebih banyak',
    groups: {
      today: 'Hari ini',
      thisWeek: 'Minggu ini',
      older: 'Lebih lama'
    },
    cta: {
      viewBids: 'Lihat tawaran',
      continueFinalization: 'Lanjutkan finalisasi',
      openWorkspace: 'Buka workspace',
      completeBrief: 'Lengkapi brief',
      openProject: 'Buka proyek'
    },
    emptyTitle: 'Belum ada notifikasi',
    emptyMessage: 'Anda akan diberitahu tentang pembaruan proyek dan tawaran di sini',
    justNow: 'Baru saja',
    minutesAgo: '{n} menit yang lalu',
    hoursAgo: '{n} jam yang lalu',
    daysAgo: '{n} hari yang lalu',
    messages: {
      NOTIFICATION_PROJECT_VALIDATED: {
        title: 'Proyek Disetujui',
        message: 'Proyek Anda "{projectName}" telah divalidasi dan sekarang aktif'
      },
      NOTIFICATION_PROJECT_REJECTED: {
        title: 'Tinjauan Proyek',
        message: 'Proyek Anda "{projectName}" memerlukan peninjauan: {reason}'
      },
      NOTIFICATION_BID_RECEIVED: {
        title: 'Tawaran Baru Diterima',
        message: '{architectName} mengajukan tawaran sebesar Rp {amount} untuk "{projectName}"'
      },
      NOTIFICATION_BID_ACCEPTED: {
        title: 'Tawaran Diterima',
        message: 'Tawaran Anda untuk "{projectName}" telah diterima!'
      },
      NOTIFICATION_BID_REJECTED: {
        title: 'Update Tawaran',
        message: 'Tawaran Anda untuk "{projectName}" tidak terpilih'
      },
      NOTIFICATION_TOKEN_PURCHASE_SUCCESS: {
        title: 'Pembelian Selesai',
        message: '{tokenCount} token bid telah ditambahkan ke akun Anda'
      },
      NOTIFICATION_SUBSCRIPTION_ACTIVATED: {
        title: 'Langganan Aktif',
        message: 'Langganan {tier} Anda sekarang aktif dengan {tokenCount} token'
      },
      NOTIFICATION_SUPPORT_REQUESTED: {
        title: 'Permintaan Dukungan',
        message: 'Seorang pengguna meminta dukungan IT'
      }
    }
  },
  support: {
    requestSupport: 'Minta Dukungan IT',
    opening: 'Membuka...',
    openError: 'Gagal membuka chat dukungan',
    chatTitle: 'Chat Dukungan IT',
    chatSubtitle: 'Tim kami akan segera merespons',
    close: 'Tutup',
    dashboard: {
      title: 'Permintaan Dukungan IT',
      subtitle: 'Percakapan dukungan masuk dari arsitek dan klien',
      empty: 'Belum ada permintaan dukungan.',
      loading: 'Memuat...',
      selectPrompt: 'Pilih permintaan dukungan untuk mulai mengobrol',
      projectRef: 'Proyek',
      bidRef: 'Penawaran'
    }
  },
  myBids: {
    title: 'Penawaran Saya',
    subtitle: 'Lacak penawaran yang telah Anda kirim',
    empty: {
      title: 'Belum ada penawaran',
      message: 'Kirim penawaran pertama Anda untuk memulai',
      cta: 'Lihat Peluang'
    }
  },
  opportunityList: {
    title: 'Peluang Tersedia',
    subtitle: 'Jelajahi proyek terbuka dan kirim penawaran Anda',
    tokensAvailable: 'Token Bid Tersisa',
    tokensUsedThisMonth: 'Digunakan Bulan Ini',
    purchaseTokens: 'Beli Token',
    empty: {
      title: 'Tidak ada proyek terbuka',
      message: 'Cek kembali nanti untuk peluang baru'
    }
  },
  phasePayments: {
    loading: 'Memuat jadwal pembayaran...',
    title: 'Jadwal Pembayaran',
    subtitle: 'Fase Proyek',
    tryAgain: 'Coba lagi',
    inProgressBanner: 'Proyek Anda kini berjalan. Bayar setiap fase seiring pekerjaan diserahkan.',
    noPhases: 'Tidak ada fase pembayaran untuk proyek ini.',
    phase: 'Fase',
    processing: 'Memproses...',
    payNow: 'Bayar Sekarang',
    paid: 'Dibayar',
    deliverables: 'Deliverable',
    totalValue: 'Total Nilai Proyek',
    remaining: 'Sisa',
    statusPending: 'Tertunda',
    statusPaid: 'Dibayar',
    statusExpired: 'Kedaluwarsa',
    statusProcessing: 'Diproses'
  },
  projectDetailV2: {
    crumbProjects: 'Proyek',
    crumbFindProjects: 'Find Projects',
    crumbMyBids: 'My Bids',
    needsClient: 'Kebutuhan Anda',
    needsArchitect: 'Kebutuhan klien',
    scopeTitle: 'Lingkup proyek',
    interiorAreas: 'Area interior',
    interiorArea: 'Interior',
    documentsTitle: 'Dokumen yang dibutuhkan',
    documentsCount: '{n} dokumen dipilih',
    otherDocuments: 'Lainnya',
    refsTitle: 'Referensi dan lampiran',
    refsHintClient: 'Gambar dan berkas yang Anda lampirkan saat mengisi brief.',
    refsHintArchitect: 'Gambar dan berkas dari klien. Gunakan sebagai acuan, bukan spesifikasi.',
    millionShort: 'Jt',
    thousandShort: 'Rb',
    feeArchitect: 'Budget fee arsitek',
    feeArchitectSub: 'Di luar biaya bangun',
    feeDesign: 'Budget fee desain',
    feeDesignSub: 'Di luar pembuatan',
    lotSize: 'Luas tanah',
    lotSizeSub: 'Sesuai data klien',
    projectArea: 'Area proyek',
    projectAreaSub: 'Luas bangunan',
    floors: 'Jumlah lantai',
    floorsValue: '{n} lantai',
    floorsUnknown: 'Belum ditentukan',
    unitType: 'Tipe unit',
    unitTypeSub: 'Unit apartemen',
    area: 'Area',
    areaSub: 'Perkiraan klien',
    wallLength: 'Panjang dinding',
    wallLengthSub: 'Untuk furnitur terpasang',
    startDesign: 'Mulai desain',
    startImmediately: 'Secepatnya',
    submitted: 'Dikirim',
    briefSubmitted: 'Brief dikirim',
    notesTitle: 'Catatan dari tim rumantra',
    closesIn: 'Penawaran ditutup dalam',
    closesInValue: '{d} hari {h} jam',
    biddingClosed: 'Penawaran sudah ditutup',
    pendingTitle: 'Brief Anda sedang divalidasi',
    pendingBody:
      'Tim rumantra memeriksa kelengkapan brief sebelum dibuka untuk arsitek. Selama proses ini brief tidak bisa diubah.',
    pendingFootnote:
      'Kami akan memberi tahu Anda lewat email dan notifikasi begitu brief terbuka untuk penawaran.',
    rejectedTitle: 'Brief perlu diperbaiki',
    rejectedBody: 'Ada beberapa hal yang perlu dilengkapi sebelum brief dibuka untuk arsitek.',
    rejectedFootnote:
      'Brief ini belum bisa diubah dari halaman ini. Anda bisa mengirim brief baru dengan data yang sudah diperbaiki.',
    stepSubmitted: 'Brief dikirim',
    stepValidating: 'Validasi tim rumantra',
    stepValidatingMeta: 'Biasanya selesai dalam 1×24 jam',
    stepRejected: 'Perlu perbaikan',
    stepResubmit: 'Kirim ulang',
    stepResubmitMeta: 'Divalidasi kembali dalam 1×24 jam',
    stepOpen: 'Terbuka untuk penawaran',
    stepOpenMeta: 'Arsitek terverifikasi mengirim penawaran',
    stepCompare: 'Bandingkan dan pilih',
    stepCompareMeta: 'Pilih satu penawaran untuk dilanjutkan',
    archOpenTitle: 'Terbuka untuk penawaran',
    archOpenBody:
      'Kirim penawaran dengan jadwal tahap pembayaran. Klien membandingkan penawaran sebelum memilih.',
    archOpenCta: 'Buat penawaran',
    archDraftTitle: 'Penawaran Anda masih draf',
    archDraftBody:
      'Penawaran tersimpan tetapi belum dikirim. Selesaikan sebelum penawaran ditutup.',
    archDraftCta: 'Lanjutkan penawaran',
    archSentTitle: 'Penawaran Anda terkirim',
    archSentBody:
      'Klien sedang membandingkan penawaran. Anda akan diberi tahu jika penawaran Anda dipilih.',
    archSentCta: 'Lihat penawaran',
    archFootnote: 'Kontak klien dibagikan setelah penawaran Anda diterima.',
    bidAmount: 'Nilai penawaran',
    bidDuration: 'Durasi',
    bidDays: '{n} hari',
    bidSent: 'Dikirim',
    bidOverview: 'Profil studio',
    bidConcept: 'Konsep desain',
    bidViewBrief: 'Lihat brief proyek',
    bidEdit: 'Ubah penawaran',
    bidAcceptedTitle: 'Penawaran Anda diterima',
    bidAcceptedBody: 'Klien memilih penawaran Anda. Konfirmasi ketentuan di halaman finalisasi.',
    bidAcceptedWorkingBody: 'Proyek sedang berjalan. Lanjutkan di workspace.',
    openWorkspace: 'Buka workspace',
    loadError: 'Gagal memuat detail',
    retry: 'Coba lagi'
  },
  projectDetailArchitect: {
    bidNotSelected: 'Penawaran tidak terpilih',
    bidNotSelectedDesc:
      'Klien memilih arsitek lain untuk proyek ini. Penawaran Anda tetap tersimpan sebagai arsip.',
    bidWithdrawn: 'Penawaran ditarik',
    bidWithdrawnDesc: 'Anda menarik penawaran ini. Proyek ditampilkan di sini sebagai arsip.',
    projectClosed: 'Proyek ditutup',
    projectClosedDesc: 'Proyek ini sudah tidak aktif dan tidak menerima penawaran.',
    designBudgetRange: 'Rentang Anggaran Desain',
    lotSize: 'Luas Lahan',
    buildArea: 'Luas Bangunan',
    buildAreaNotSpecified: 'Belum ditentukan — silakan usulkan',
    floors: 'Lantai',
    visualReferences: 'Referensi Visual',
    visualReferencesHint: 'Klik gambar untuk melihat ukuran penuh.',
    siteLocation: 'Lokasi & Situs',
    fullAddress: 'Alamat Lengkap',
    viewSatellite: 'Satelit',
    viewRoadmap: 'Peta',
    mapUnavailable: 'Pratinjau peta tidak tersedia.',
    mapLoading: 'Memuat peta...',
    projectDocuments: 'Dokumen Proyek',
    scopeOfWork: 'Lingkup Pekerjaan',
    deliverables: 'Deliverable',
    expectedStartDate: 'Tanggal Mulai yang Diharapkan',
    immediately: 'Segera — bisa langsung dimulai',
    designPreferences: 'Preferensi Desain',
    bidAccepted: 'Penawaran Diterima',
    bidAcceptedDesc: 'Tinjau ketentuan dan konfirmasi untuk memulai proyek.',
    finalizeAgreement: 'Finalisasi Perjanjian',
    bidSubmitted: 'Penawaran Terkirim',
    bidSubmittedDesc: 'Penawaran Anda sedang ditinjau oleh klien.',
    draftSaved: 'Draft Tersimpan',
    draftSavedDesc: 'Lanjutkan mengedit untuk melengkapi penawaran Anda.',
    bidRejected: 'Penawaran Tidak Terpilih',
    bidRejectedDesc: 'Penawaran Anda tidak terpilih untuk proyek ini.',
    noBidYet: 'Buat Penawaran',
    noBidYetDesc: 'Kirim penawaran untuk bersaing mendapatkan proyek ini.',
    projectClosedBidding: 'Proyek Ditutup',
    projectClosedBiddingDesc: 'Periode bidding untuk proyek ini telah berakhir.'
  },
  bidComparison: {
    bidA: 'Penawaran A',
    bidB: 'Penawaran B',
    appointed: '✓ Ditunjuk',
    appointLead: 'Tunjuk Arsitek Utama',
    appointModalEyebrow: 'Konfirmasi Penunjukan',
    appointModalTitle: 'Tunjuk sebagai Arsitek Utama?',
    appointModalWarningTitle: 'Harap Baca Sebelum Konfirmasi',
    appointModalWarningItem1:
      'Proyek akan langsung berpindah ke tahap negosiasi dengan arsitek ini.',
    appointModalWarningItem2: 'Penawaran arsitek lain tidak akan tersedia lagi untuk dibandingkan.',
    appointModalWarningItem3: 'Tindakan ini tidak dapat dibatalkan setelah dikonfirmasi.',
    appointModalCancel: 'Batal',
    appointModalConfirm: 'Ya, Tunjuk Sekarang',
    appointModalLoading: 'Menunjuk...',
    visualOverlay: 'Overlay Visual',
    sideBySize: 'Tinjauan Desain Berdampingan',
    adjustSlider: 'Geser untuk perbandingan relatif',
    facade: 'Fasad',
    interior: 'Interior',
    massing: 'Massing',
    zoning: 'Zoning',
    noImages: 'Tidak ada gambar {type}',
    reviewing: 'Meninjau',
    conceptStatements: 'Konsep Desain',
    studioOverview: 'Profil Studio',
    conceptStatement: 'Pernyataan Konsep',
    noStudioOverview: 'Tidak ada profil studio.',
    noConceptStatement: 'Tidak ada pernyataan konsep.',
    summaryStats: 'Ringkasan Statistik',
    metricHeader: 'Metrik',
    costEstimate: 'Estimasi Biaya',
    timeline: 'Timeline',
    portfolios: 'Portofolio',
    noPortfolios: 'Tidak ada portofolio terlampir',
    scopeAlignment: 'Kesesuaian Scope',
    paymentScheduleTitle: 'Jadwal Pembayaran',
    noPhases: 'Tidak ada fase pembayaran',
    deliverable: 'deliverable',
    deliverables: 'deliverable',
    days: 'hari',
    imageOf: '{current} dari {total}',
    prevImage: 'Gambar sebelumnya',
    nextImage: 'Gambar berikutnya',
    matchingDeliverable: 'Sesuai kebutuhan proyek',
    additionalDeliverable: 'Tambahan dari arsitek',
    missingDeliverable: 'Belum tercakup dalam penawaran',
    uncoveredTitle: 'Belum tercakup dari kebutuhan proyek',
    paymentFlowInfo: 'Lihat detail alur pembayaran',
    paymentFlowTitle: 'Alur Pembayaran',
    paymentFlowUpfront: '{amount} dibayarkan di muka saat fase ini dimulai.',
    paymentFlowTimelineWithDeliverables:
      'Dengan asumsi tidak ada permintaan revisi, arsitek akan menyelesaikan dan menyerahkan {deliverables} dalam waktu {days} hari.',
    paymentFlowTimeline:
      'Dengan asumsi tidak ada permintaan revisi, fase ini akan diselesaikan dalam waktu {days} hari.',
    paymentFlowRevisions:
      'Fase ini mencakup hingga {rounds} putaran revisi apabila diperlukan penyesuaian.'
  },
  paymentPhaseBuilder: {
    availableDeliverables: 'Deliverable Tersedia',
    availableDeliverablesHelp:
      'Klik deliverable untuk menetapkannya ke fase aktif, atau seret ke fase tertentu.',
    paymentPhases: 'Fase Pembayaran',
    addPhase: '+ Tambah Fase',
    phasesTotal: 'Total fase',
    percentage: 'Persentase (%)',
    revisionRounds: 'Putaran revisi',
    estimatedDays: 'Est. hari',
    daysTotal: 'Total durasi',
    phase: 'Fase',
    dropZoneHint: 'Seret deliverable ke sini atau klik di atas untuk menetapkan',
    selectAll: 'Pilih semua',
    addAllRequired: '+ Tambah semua wajib'
  },
  bidDetail: {
    imageArchived: 'Gambar tidak lagi tersedia',
    backToProject: 'Kembali ke Proyek',
    proposedCost: 'Biaya yang Diajukan',
    timeline: 'Timeline',
    days: 'hari',
    studioOverview: 'Profil Studio',
    noStudioOverview: 'Tidak ada profil studio.',
    designConcept: 'Konsep Desain',
    paymentSchedule: 'Jadwal Pembayaran',
    portfolioProjects: 'Proyek Portofolio Terkait',
    facade: 'Fasad',
    noFacade: 'Tidak ada gambar fasad',
    interior: 'Interior',
    noInterior: 'Tidak ada gambar interior',
    massing: 'Massing',
    noMassing: 'Tidak ada gambar massing',
    zoning: 'Zoning',
    noZoning: 'Tidak ada gambar zoning',
    acceptBid: 'Terima Penawaran Ini',
    accepted: 'Diterima',
    submittedOn: 'Dikirim pada {date}',
    matchingDeliverable: 'Sesuai kebutuhan proyek',
    additionalDeliverable: 'Tambahan dari arsitek',
    missingDeliverable: 'Belum tercakup dalam penawaran',
    uncoveredTitle: 'Belum tercakup dari kebutuhan proyek'
  },
  bidCard: {
    appointed: 'Ditunjuk',
    concept: 'Konsep',
    selectedForCompare: 'Dipilih untuk Dibandingkan',
    addToCompare: 'Tambah untuk Dibandingkan',
    viewDetails: 'Lihat Detail Lengkap'
  },
  portfolioPopup: {
    built: 'Terbangun',
    concept: 'Konsep',
    noDescription: 'Tidak ada deskripsi.'
  },
  bidTable: {
    studio: 'Studio',
    rating: 'Rating',
    ratingComingSoon: 'Rating segera hadir',
    location: 'Lokasi',
    education: 'Pendidikan',
    noEducation: '—',
    totalPrice: 'Total Harga',
    totalDuration: 'Total Durasi',
    detail: 'Detail',
    filterByCity: 'Kota',
    allCities: 'Semua Kota',
    priceMin: 'Harga Min',
    priceMax: 'Harga Maks',
    clearFilters: 'Hapus filter',
    noPendingBids: 'Belum ada penawaran yang tertunda',
    noBidsMatchFilters: 'Tidak ada penawaran yang cocok dengan filter Anda',
    minPrice: 'Harga Min',
    avgPrice: 'Harga Rata-rata',
    maxPrice: 'Harga Maks',
    minDuration: 'Durasi Min',
    avgDuration: 'Durasi Rata-rata',
    maxDuration: 'Durasi Maks'
  },
  projectCard: {
    manage: 'Kelola →',
    continueDraft: 'Lanjutkan Draf →',
    minutesAgo: '{n} mnt lalu',
    hoursAgo: '{n} jam lalu',
    daysAgo: '{n} hari lalu',
    monthsAgo: '{n} bulan lalu'
  },
  clientFinalization: {
    itSupportInvited: 'Dukungan IT diundang',
    winningBid: 'Penawaran Terpilih',
    paymentSchedule: 'Jadwal Pembayaran',
    phase: 'Fase',
    revisionRound: 'putaran revisi',
    revisionRounds: 'putaran revisi',
    total: 'Total',
    discussionSubtitle: 'Diskusikan ketentuan dengan arsitek',
    clientPanel: {
      confirmed: 'Anda telah mengkonfirmasi',
      architectAlsoConfirmed: 'Arsitek juga telah mengkonfirmasi.',
      awaitingArchitect: 'Menunggu konfirmasi arsitek...',
      confirmPrompt:
        'Tinjau syarat penawaran dan diskusikan dengan arsitek sebelum mengkonfirmasi.',
      confirmButton: 'Konfirmasi & Lanjut ke Pembayaran',
      confirmDialog: 'Konfirmasi ketentuan dan lanjutkan ke pembayaran?',
      confirming: 'Mengkonfirmasi...',
      rejectButton: 'Tolak Syarat & Buka Kembali Bidding'
    },
    architectPanel: {
      confirmed: 'Anda telah mengkonfirmasi',
      clientAlsoConfirmed: 'Klien juga telah mengkonfirmasi.',
      awaitingClient: 'Menunggu konfirmasi klien...',
      confirmPrompt:
        'Tinjau ketentuan yang disepakati dan konfirmasi untuk melanjutkan proyek ini.',
      confirmButton: 'Konfirmasi & Lanjut ke Pembayaran'
    },
    rejectDialog: {
      title: 'Tolak Syarat & Buka Kembali Bidding?',
      message:
        'Ini akan menolak penawaran, mengembalikan token arsitek, dan membuka kembali proyek untuk penawaran baru. Tindakan ini tidak dapat dibatalkan.',
      cancel: 'Batal',
      confirm: 'Ya, Tolak & Buka Kembali',
      rejecting: 'Menolak...',
      successToast: 'Bidding berhasil dibuka kembali',
      error: 'Gagal menolak ketentuan'
    }
  },
  errors: {
    CONTRACT_NOT_AVAILABLE: 'Kontrak belum siap — penawaran harus diterima terlebih dahulu.',
    CONTRACT_ALREADY_SIGNED: 'Anda sudah menandatangani kontrak ini.',
    CONTRACT_SIGNATURE_MISMATCH: 'Tanda tangan harus sama dengan nama pada akun Anda.',
    CONTRACT_STALE: 'Kontrak telah diperbarui. Silakan buka kembali dan tandatangani ulang.',
    CONTRACT_NOT_ACCEPTED: 'Silakan baca dan setujui perjanjian kontrak terlebih dahulu.',
    'firstName.required': 'Nama depan wajib diisi',
    'lastName.required': 'Nama belakang wajib diisi',
    'name.verified.cannot.modify': 'Tidak dapat mengubah nama setelah verifikasi KTP',
    'phone.required': 'Nomor telepon wajib diisi',
    'phone.invalid.format': 'Format nomor telepon tidak valid. Harus 10-16 digit.',
    'ktp.required': 'Nomor KTP wajib diisi',
    'ktp.invalid.format': 'Nomor KTP harus tepat 16 digit',
    'ktp.verified.cannot.modify': 'Tidak dapat mengubah nomor KTP setelah verifikasi',
    BID_NOT_DRAFT: 'Penawaran hanya bisa dikirim saat berstatus draft.',
    BID_NOT_FOUND: 'Penawaran tidak ditemukan.',
    BID_IMAGE_NOT_FOUND: 'Gambar penawaran tidak ditemukan.',
    UNAUTHORIZED_BID_ACCESS: 'Anda tidak diizinkan mengakses penawaran ini.',
    ALREADY_BASIC_TIER: 'Anda sudah berlangganan paket Basic.',
    UNAUTHORIZED_ARCHITECT_ACCESS: 'Anda tidak diizinkan mengakses profil arsitek ini.',
    ARCHITECT_NOT_FOUND: 'Arsitek tidak ditemukan.',
    PROJECT_NOT_FOUND: 'Proyek tidak ditemukan.',
    INVALID_PURCHASE_QUANTITY: 'Jumlah pembelian token tidak valid.',
    PURCHASE_NOT_FOUND: 'Pembelian token tidak ditemukan.',
    UNAUTHORIZED_PURCHASE_ACCESS: 'Anda tidak diizinkan mengakses pembelian ini.',
    XENDIT_PAYMENT_ERROR: 'Gagal memproses pembayaran. Silakan coba lagi.',
    UNAUTHORIZED_PROJECT_ACCESS: 'Anda tidak diizinkan mengakses proyek ini.',
    PURCHASE_ALREADY_COMPLETED: 'Pembelian ini sudah selesai diproses.',
    ATTACHMENT_NOT_FOUND: 'Lampiran tidak ditemukan.',
    ATTACHMENT_MODIFY_NOT_DRAFT: 'Lampiran hanya bisa diubah saat proyek masih dalam status draft.',
    ATTACHMENT_EMPTY_FILE: 'File kosong.',
    ATTACHMENT_INVALID_TYPE: 'Tipe file tidak valid.',
    ATTACHMENT_SIZE_EXCEEDED: 'Ukuran file melebihi batas maksimum.',
    PHASE_NOT_FOUND: 'Fase pembayaran tidak ditemukan.',
    PHASE_ALREADY_PAID: 'Fase ini sudah dibayar.',
    STALE_TERMS: 'Syarat & Ketentuan telah diperbarui, silakan tinjau dan setujui kembali.',
    MISSING_REQUIRED_ACCEPTANCE: 'Mohon setujui Syarat & Ketentuan dan Kebijakan Privasi.'
  },
  clientNav: {
    dashboard: 'Dasbor',
    projects: 'Proyek',
    messages: 'Pesan',
    payments: 'Pembayaran'
  },
  clientPaymentsPage: {
    title: 'Pembayaran',
    subtitle: 'Proyek Aktif',
    selectProject: 'Pilih proyek untuk melihat dan mengelola pembayaran fase.',
    noProjects: 'Tidak ada proyek aktif dengan pembayaran',
    noProjectsHint: 'Proyek muncul di sini setelah kedua pihak mengkonfirmasi kesepakatan.',
    viewProjects: 'Lihat proyek saya →',
    phase: 'Fase',
    of: 'dari',
    pending: 'menunggu',
    allPaid: 'Semua terbayar'
  },
  activeProjectDashboard: {
    paidRefresh: 'Sudah Dibayar — Refresh',
    processing: 'Memproses...',
    payNow: 'Bayar Sekarang',
    payNowAgain: 'Bayar Lagi',
    deliverables: 'Deliverable',
    loading: 'Memuat proyek...',
    tryAgain: 'Coba lagi',
    projectDashboard: 'Dashboard Proyek',
    inProgress: 'Sedang Berlangsung',
    phase: 'Fase',
    of: 'dari',
    openWorkspace: 'Buka Workspace',
    budget: 'Anggaran',
    totalValue: 'Total Nilai',
    paid: 'Terbayar',
    remaining: 'Tersisa',
    architect: 'Arsitek',
    scopeOfWork: 'Lingkup Pekerjaan',
    noPhases: 'Tidak ada fase pembayaran untuk proyek ini.',
    expired: 'Kedaluwarsa',
    pending: 'Menunggu',
    payFirst: 'terlebih dahulu',
    phases: 'fase',
    percentComplete: '% selesai'
  },
  projectWorkspace: {
    payNow: 'Bayar Sekarang',
    getLink: 'Dapatkan Link Pembayaran',
    payoutProcessing: 'Pencairan Sedang Diproses',
    payoutProcessingHint: 'Transfer sedang diverifikasi oleh Xendit. Harap tunggu konfirmasi.',
    payoutFailed: 'Pencairan Gagal',
    payoutFailedHint:
      'Transfer gagal diproses. Silakan coba lagi dengan detail rekening yang benar.',
    retryPayout: 'Coba Lagi',
    requestPayout: 'Cairkan Dana',
    deadline: 'Tenggat',
    remaining: 'tersisa',
    initialDelivery: 'Pengiriman Awal',
    revisionRound: 'Revisi',
    revisionEachRequired: 'Isi komentar untuk setiap deliverable yang Anda tandai.',
    revisionPooledHint: 'Semua {n} dikirim bersamaan dan hanya memakai satu jatah revisi.',
    revisionRoundLabel: 'Revisi {n}',
    deliverableRevisionRequested: 'Perlu revisi',
    reviseCta: 'Revisi',
    reviseUndoCta: 'Batal',
    reviseFromTableHint: 'Perlu perubahan? Tandai deliverable di bawah dengan Revisi.',
    revisionBasketTitle: 'Deliverable yang perlu direvisi',
    revisionBasketHint: 'Jelaskan ke arsitek apa yang harus diubah pada masing-masing.',
    revisionCommentLabel: 'Komentar',
    revisionSubmitCta: 'Kirim permintaan revisi',
    revisionConfirmTitle: 'Ini memakai satu jatah revisi',
    revisionConfirmWarning: 'Mengirim ini memakai 1 dari {max} revisi untuk fase ini. Sisa {left}.',
    revisionConfirmSubmit: 'Ya, minta revisi',
    revisionModalTitle: 'Catatan Revisi',
    revisionModalHint: 'Jelaskan perubahan yang Anda butuhkan dari arsitek.',
    revisionModalPlaceholder: 'mis. Mohon sesuaikan denah lantai untuk mencakup...',
    revisionModalSubmit: 'Minta Revisi',
    revisionModalCancel: 'Batal',
    revisionModalRequired: 'Silakan jelaskan perubahan yang diperlukan.',
    completed: 'Proyek Selesai',
    active: 'Proyek Aktif',
    archiving: 'Mengarsipkan...',
    archiveToPortfolio: 'Arsipkan ke Portofolio',
    viewInPortfolio: 'Lihat di Portofolio',
    archiveError: 'Gagal mengarsipkan proyek ke portofolio',
    loading: 'Memuat workspace...',
    tryAgain: 'Coba lagi',
    loadError: 'Gagal memuat workspace',
    eyebrow: 'Workspace Proyek',
    titleFallback: 'Proyek Aktif',
    of: 'dari',
    phasesDone: 'fase selesai',
    completedBadge: 'Selesai',
    inProgressBadge: 'Dalam Proses',
    viewDetail: 'Lihat Detail ↗',
    totalValue: 'Total Nilai',
    paidLabel: 'terbayar',
    paymentPhasesTitle: 'Fase Pembayaran',
    noPhasesTitle: 'Belum ada fase',
    noPhasesDesc: 'Detail fase akan muncul setelah arsitek menyiapkannya.',
    initializing: 'Menginisialisasi...',
    initPhasesBtn: 'Inisialisasi Fase dari Penawaran',
    phaseFallback: 'Fase {n}',
    descriptionLabel: 'Deskripsi',
    revisionsLeftLabel: 'Sisa Revisi',
    revisionsExhausted: 'Revisi habis',
    actionsLabel: 'Tindakan',
    notStartedTitle: 'Belum Dimulai',
    notStartedDesc: 'Fase ini akan aktif setelah fase sebelumnya selesai sepenuhnya.',
    paymentRequiredTitle: 'Pembayaran Diperlukan',
    paymentRequiredDesc:
      'Buat invoice untuk memulai fase ini. Arsitek dapat mulai bekerja setelah pembayaran dikonfirmasi.',
    creating: 'Membuat...',
    createInvoice: 'Buat Invoice',
    invoiceSentTitle: 'Invoice Terkirim',
    invoiceSentDesc: 'Menunggu konfirmasi pembayaran.',
    workInProgressTitle: 'Pekerjaan Berlangsung',
    workInProgressDesc:
      'Arsitek sedang mengerjakan fase ini. Deliverable akan muncul di bawah ketika dikirimkan.',
    workSubmittedTitle: 'Pekerjaan Dikirimkan',
    workSubmittedDesc:
      'Tinjau deliverable di bawah, lalu setujui, minta revisi, atau laporkan kendala.',
    approveBtn: 'Setujui',
    requestRevisionBtn: 'Minta Revisi',
    disputeBtn: 'Laporkan Kendala',
    disputeLinkBtn: 'Atau laporkan kendala',
    disputeModalTitle: 'Laporkan Kendala',
    disputeModalDesc: 'Tim dukungan kami akan meninjau fase ini dan menghubungi kedua pihak.',
    disputeReasonLabel: 'Rincian Kendala',
    disputeReasonPlaceholder:
      'Jelaskan apa yang tidak sesuai dengan spesifikasi yang disepakati...',
    submitting: 'Mengirimkan...',
    submitDispute: 'Kirim Laporan',
    cancel: 'Batal',
    workApprovedTitle: 'Pekerjaan Disetujui',
    workApprovedDesc: 'Anda menyetujui fase ini. Arsitek sedang memproses pencairan dana.',
    underDisputeTitle: 'Dalam Peninjauan',
    underDisputeDesc:
      'Fase ini sedang ditinjau oleh tim dukungan kami. Kedua pihak akan dihubungi.',
    phaseCompleteDisbursed: 'Fase selesai. Dana telah dicairkan ke arsitek.',
    deliverablesLabel: 'Deliverable',
    fileCountSuffix: 'file',
    noDeliverablesUploaded: 'Belum ada deliverable yang diunggah',
    activityLogLabel: 'Log Aktivitas',
    loadingActivity: 'Memuat aktivitas...',
    noActivityRecorded: 'Belum ada aktivitas tercatat',
    logActions: {
      PHASE_CREATED: 'Fase dibuat',
      PHASE_BILLED: 'Invoice dibuat',
      PAYMENT_RECEIVED: 'Pembayaran diterima',
      DELIVERABLE_UPLOADED: 'File diunggah arsitek',
      PHASE_SUBMITTED_FOR_REVIEW: 'Fase dikirim untuk review',
      DELIVERABLE_APPROVED: 'Deliverable disetujui',
      REVISION_REQUESTED: 'Revisi diminta',
      DELIVERABLE_DISPUTED: 'Kendala dilaporkan',
      PAYOUT_INITIATED: 'Pencairan diajukan arsitek',
      PAYOUT_COMPLETED: 'Pencairan berhasil',
      PAYOUT_FAILED: 'Pencairan gagal'
    },
    chatTitle: 'Chat Proyek',
    activeOnProject: 'Aktif di proyek',
    chatUnavailableHint: 'Chat tersedia setelah kedua pihak mengkonfirmasi proyek.',
    projectDetailsLabel: 'Detail Proyek',
    projectInfoLabel: 'Informasi Proyek',
    locationLabel: 'Lokasi',
    categoryLabel: 'Kategori',
    buildingFunctionLabel: 'Fungsi Bangunan',
    lotSizeLabel: 'Luas Lahan',
    floorsLabel: 'Jumlah Lantai',
    designBudgetLabel: 'Anggaran Desain',
    scopeOfWorkLabel: 'Lingkup Pekerjaan',
    projectDeliverablesLabel: 'Deliverable Proyek',
    winningBidLabel: 'Penawaran Menang',
    bidAmountLabel: 'Nilai Penawaran',
    workDaysSuffix: 'hari pengerjaan',
    phasePlanLabel: 'Rencana Fase',
    days: 'hari',
    revisionsWord: 'revisi',
    closeLabel: 'Tutup',
    confirmApprovalEyebrow: 'Konfirmasi Persetujuan',
    approveModalTitle: 'Setujui Pekerjaan Fase Ini?',
    approveModalWarningTitle: '⚠️ Harap Baca Sebelum Menyetujui',
    approveModalItem1:
      'Dengan menyetujui, Anda mengkonfirmasi bahwa pekerjaan <strong>telah sesuai</strong> dengan spesifikasi yang disepakati.',
    approveModalItem2:
      'Arsitek akan dapat mengajukan <strong>pencairan dana</strong> untuk fase ini segera setelah persetujuan.',
    approveModalItem3: 'Jika ada masalah setelah persetujuan, silakan hubungi tim dukungan kami.',
    approveModalConfirmLabel: 'Dengan menyetujui:',
    approveModalConfirmDesc:
      'Anda mengonfirmasi bahwa pekerjaan yang dikirimkan telah sesuai spesifikasi yang disepakati. Arsitek akan dapat mengajukan pencairan dana segera. Tindakan ini tidak dapat dibatalkan.',
    approving: 'Menyetujui...',
    confirmApproveBtn: 'Ya, Setujui Sekarang',
    downloadLabel: 'Unduh',
    previewUnavailable: 'Preview tidak tersedia untuk tipe file ini',
    downloadFileLabel: 'Unduh File',
    statusLabels: {
      NOT_STARTED: 'Belum Dimulai',
      PENDING: 'Menunggu Bayar',
      BILLED: 'Invoice Terkirim',
      PAID: 'Sudah Dibayar',
      IN_PROGRESS: 'Sedang Berjalan',
      DELIVERED: 'Dikirimkan',
      APPROVED: 'Disetujui',
      DISBURSED: 'Selesai',
      DISPUTED: 'Ditinjau'
    },
    architectFallback: 'Arsitek',
    billError: 'Gagal membuat invoice',
    approveError: 'Gagal menyetujui fase',
    revisionError: 'Gagal meminta revisi',
    disputeError: 'Gagal mengirim laporan',
    initError: 'Gagal menginisialisasi fase',
    overdueDays: '{d} hari terlambat',
    dueToday: 'Tenggat hari ini!',
    oneDayLeft: '1 hari tersisa',
    daysLeftCount: '{d} hari tersisa',
    noDueDate: 'Tenggat belum ditentukan',
    currentPhaseLabel: 'Fase berjalan',
    progressByPhaseTitle: 'Progres per fase',
    timelineFinishLine: 'Target selesai {target} · Perkiraan {forecast}',
    timelineFinishedLine: 'Target selesai {target} · Selesai pada {forecast}',
    timelineTargetLane: 'TARGET',
    timelineActualLane: 'AKTUAL',
    timelineToday: 'Hari ini',
    timelineFinishShort: '{date} · selesai',
    timelineOpenAll: 'Fase & Deliverable',
    timelineOpenPhase: 'Klik untuk buka deliverable Fase {n}',
    timelineOpenAria: 'Buka {phase} · {title} di Fase & Deliverable',
    legendTarget: 'Target dari penawaran',
    legendCompleted: 'Selesai',
    legendInProgress: 'Sedang berjalan',
    legendForecast: 'Perkiraan',
    ackOnTrackClient: 'Arsitek Anda bekerja sesuai jadwal penawaran',
    ackOnTrackArchitect: 'Anda bekerja sesuai jadwal penawaran',
    ackOnTrackSub: 'Kecepatan dibanding penawaran muncul setelah fase pertama dikirim.',
    ackFasterClient: 'Arsitek Anda mengirim {days} lebih cepat dari penawaran',
    ackFasterArchitect: 'Anda mengirim {days} lebih cepat dari penawaran',
    ackSlowerClient: 'Arsitek Anda mengirim {days} lebih lambat dari penawaran',
    ackSlowerArchitect: 'Anda mengirim {days} lebih lambat dari penawaran',
    ackOnTimeClient: 'Arsitek Anda tepat sesuai jadwal penawaran',
    ackOnTimeArchitect: 'Anda tepat sesuai jadwal penawaran',
    ackAcrossOne: 'Dari {n} fase yang dikirim, dihitung dari mulai hingga pengiriman.',
    ackAcrossMany: 'Dari {n} fase yang dikirim, dihitung dari mulai hingga pengiriman.',
    dayCountOne: '{n} hari',
    dayCountMany: '{n} hari',
    chipFaster: '{d} hr lebih cepat',
    chipSlower: '{d} hr lebih lambat',
    chipOnSchedule: 'Tepat jadwal',
    chipDayOf: 'Hari {n} dari {total}',
    backToTimeline: 'Kembali ke timeline',
    targetFromBidLabel: 'Target · dari penawaran',
    actualLabel: 'Aktual',
    targetRangeLong: '{range} · {d} hari',
    actualRange: '{range}',
    actualDoneLong: '{range} · dikirim dalam {d} hari',
    actualAwaitingLong: 'Sejak {date} · dikirim dalam {d} hari, menunggu persetujuan',
    actualActiveLong: 'Sejak {date} · perkiraan {end}',
    actualForecastLong: 'Perkiraan {range}',
    noPhasesYet: 'Belum ada fase',
    openDeliverablesLink: 'Buka deliverable',
    approveEachDesc:
      'Tinjau dan setujui tiap deliverable di bawah. Fase otomatis selesai begitu semuanya disetujui.',
    dueOnLabel: 'tenggat {date}',
    autoDeliverDesc:
      'Fase ini otomatis dikirim ke klien untuk direview begitu semua deliverable selesai diunggah.',
    clientCountdownDesc:
      'Arsitek punya waktu sampai tenggat ini untuk mengunggah semua deliverable. Setelah lengkap, fase otomatis masuk ke review Anda.',
    totalProjectValue: 'Total Nilai Proyek',
    disbursedLabel: 'dicairkan',
    percentCompleteSuffix: 'selesai',
    phasesWord: 'fase',
    noPhasesDescArchitect: 'Detail fase akan muncul setelah klien menyiapkannya.',
    awaitingClientPaymentTitle: 'Menunggu Pembayaran Klien',
    awaitingClientPaymentDesc:
      'Klien perlu membuat invoice dan membayar fase ini sebelum Anda dapat memulai pekerjaan.',
    invoiceSentDescArchitect:
      'Invoice sudah dikirim ke klien. Anda akan diberitahu setelah pembayaran dikonfirmasi.',
    workPhaseActiveTitle: 'Fase Aktif',
    workPhaseActiveDesc:
      'Pembayaran dikonfirmasi. Unggah deliverable Anda ketika siap untuk direview klien.',
    uploadFileLabel: 'Unggah File',
    chooseFileLabel: 'Pilih file',
    fileDescPlaceholder: 'Deskripsi file (opsional)',
    uploading: 'Mengunggah...',
    uploadBtn: 'Unggah',
    markCompleteLabel: 'Tandai Selesai',
    markCompleteDesc:
      'Setelah semua file diunggah, kirim fase ini untuk direview oleh klien. Klien akan diberi notifikasi.',
    submitForReviewBtn: 'Kirim untuk Review',
    underClientReviewTitle: 'Sedang Direview',
    underClientReviewDesc:
      'Deliverable Anda sudah dikirim. Menunggu persetujuan atau revisi dari klien.',
    workApprovedExclaim: 'Pekerjaan Disetujui!',
    workApprovedArchitectDesc: 'Klien menyetujui pekerjaan Anda. Ajukan pencairan dana di bawah.',
    payoutDetailsLabel: 'Detail Pencairan',
    selectBankPlaceholder: 'Pilih bank...',
    accountNumberLabel: 'Nomor Rekening',
    accountNumberPlaceholder: 'cth. 1234567890',
    accountHolderLabel: 'Nama Pemilik Rekening',
    accountHolderPlaceholder: 'Nama sesuai buku tabungan',
    disbursementAmountLabel: 'Jumlah pencairan',
    xenditTransferHint:
      'Transfer akan diproses melalui Xendit. Harap periksa detail rekening dengan cermat.',
    processing: 'Memproses...',
    confirmPayoutBtn: 'Konfirmasi Pencairan',
    payoutDisbursedSuccess: 'Dana berhasil dicairkan.',
    confirmPayoutEyebrow: 'Konfirmasi Pencairan',
    confirmPayoutWarning:
      'Periksa kembali detail berikut sebelum dana dicairkan melalui Xendit. Tindakan ini tidak dapat dibatalkan.',
    amountLabel: 'Jumlah',
    holderNameLabel: 'Nama Pemilik',
    confirmPayoutBtnFull: 'Ya, Cairkan Dana Sekarang',
    clientFallback: 'Klien',
    uploadError: 'Gagal mengunggah file',
    submitReviewError: 'Gagal mengirim untuk review',
    payoutError: 'Gagal mengajukan pencairan',
    statusLabelsArchitect: {
      NOT_STARTED: 'Belum Dimulai',
      PENDING: 'Menunggu',
      BILLED: 'Ditagihkan',
      PAID: 'Sudah Dibayar',
      IN_PROGRESS: 'Sedang Berjalan',
      DELIVERED: 'Dikirimkan',
      APPROVED: 'Disetujui',
      DISBURSED: 'Dicairkan',
      DISPUTED: 'Ditinjau'
    },
    logActionsArchitect: {
      PHASE_CREATED: 'Fase dibuat',
      PHASE_BILLED: 'Invoice dibuat',
      PAYMENT_RECEIVED: 'Pembayaran diterima',
      DELIVERABLE_UPLOADED: 'File diunggah',
      PHASE_SUBMITTED_FOR_REVIEW: 'Fase dikirim untuk review',
      DELIVERABLE_APPROVED: 'Deliverable disetujui klien',
      REVISION_REQUESTED: 'Revisi diminta klien',
      DELIVERABLE_DISPUTED: 'Kendala dilaporkan klien',
      PAYOUT_INITIATED: 'Pencairan diajukan',
      PAYOUT_COMPLETED: 'Pencairan berhasil',
      PAYOUT_FAILED: 'Pencairan gagal'
    },
    tabSummary: 'Ringkasan',
    tabPhases: 'Tahap & Deliverable',
    tabContract: 'Kontrak & Pembayaran',
    projectChatBtn: 'Obrolan Proyek',
    hideChatBtn: 'Sembunyikan Obrolan',
    needsActionLabel: 'Perlu tindakan Anda',
    nothingWaiting: 'Tidak ada yang menunggu Anda saat ini',
    allPhasesLink: 'Semua tahap',
    reviewCta: 'Tinjau',
    uploadCta: 'Unggah',
    colDeliverable: 'Deliverable',
    colStatus: 'Status',
    colAction: 'Tindakan',
    colFiles: 'Berkas',
    approvedOf: '{approved} dari {total} disetujui',
    awaitingUpload: 'Menunggu unggahan',
    unlocksWithPhase: 'Terbuka bersama tahap ini',
    filesUpdated: '{n} berkas \u00b7 diperbarui {at}',
    noFilesLabel: 'Tidak ada berkas',
    untaggedFilesLabel: 'Berkas lainnya',
    filesCountLabel: '{n} berkas',
    deliverableApproved: 'Disetujui',
    deliverableAwaiting: 'Menunggu persetujuan',
    deliverableMissing: 'Belum dikirim',
    deliverableLocked: 'Terkunci',
    filesModalEyebrow: 'Berkas untuk deliverable',
    filesTaggedTo: '{n} berkas terkait deliverable ini \u00b7 {phase}',
    previewBtn: 'Pratinjau',
    contractLede:
      'Dana ditahan di escrow rumantra dan dicairkan per tahap setelah Anda menyetujui pekerjaan.',
    colPhase: 'Tahap',
    colDeadline: 'Tenggat',
    colAmount: 'Jumlah',
    shareOfContract: '{share}% dari nilai kontrak',
    percentComplete: '{pct}% selesai',
    downloadPdfBtn: 'Unduh PDF',
    requestAmendmentBtn: 'Ajukan Perubahan',
    transactionHistoryLabel: 'Riwayat Transaksi',
    noTransactions: 'Belum ada transaksi',
    closedLabel: 'Ditutup',
    showLabel: 'Tampilkan',
    hideLabel: 'Sembunyikan',
    toastPhaseApproved: 'Semua deliverable disetujui \u00b7 fase disetujui',
    toastItemApproved: 'Disetujui \u00b7 {name}',
    paidToDateLabel: 'Sudah dibayarkan',
    disbursedToYouLabel: 'Sudah dicairkan',
    heldInEscrowLabel: 'Dana diamankan',
    notYetFundedLabel: 'Belum didanai',
    createInvoiceInContract: 'Buat invoice di Kontrak & Pembayaran',
    payInContract: 'Bayar di Kontrak & Pembayaran',
    payoutInContract: 'Cairkan dana di Kontrak & Pembayaran',
    deliverablesAwaitingTitle: '{n} deliverable menunggu keputusan Anda',
    reviewDeliverablesCta: 'Tinjau deliverable',
    deliverablesUploadedCount: '{done} dari {total} deliverable terunggah',
    uploadAtLeastOne: 'Unggah minimal satu deliverable sebelum mengirim',
    deliverablesMissingCount: '{n} deliverable belum diunggah',
    notSubmittedYet: 'Sudah diunggah, belum dikirim \u2014 klien belum bisa meninjaunya',
    reuploadCta: 'Unggah ulang'
  },
  architectDashboard: {
    welcome: 'Selamat datang',
    manageProjects: 'Kelola tawaran arsitektur Anda',
    findProjects: 'CARI PROYEK',
    activeBids: 'Tawaran Aktif',
    accepted: 'Diterima',
    bidTokens: 'Token Tawaran',
    myBids: 'TAWARAN SAYA',
    viewAll: 'LIHAT SEMUA →',
    noBidsYet: 'Belum ada tawaran yang diajukan',
    browseProjects: 'Jelajahi Proyek',
    tokensRemaining: 'tersisa',
    plan: 'Paket:',
    buyTokens: 'BELI TOKEN →',
    opportunities: 'Peluang',
    findNewProjects: 'Temukan Proyek Baru',
    browseProjectsDesc: 'Jelajahi proyek terbuka dari klien yang mencari arsitek.',
    browseProjectsBtn: 'JELAJAHI PROYEK →'
  },
  superuserDashboard: {
    title: 'Dashboard Backoffice',
    subtitle: 'Ringkasan platform untuk operasi superuser',
    pendingApproval: 'Menunggu Persetujuan',
    pendingApprovalDesc: 'proyek menunggu validasi',
    negotiation: 'Negosiasi',
    negotiationDesc: 'proyek dalam negosiasi',
    activeDisputes: 'Sengketa Aktif',
    activeDisputesDesc: 'fase dalam status DISPUTED',
    inProgress: 'Sedang Berlangsung',
    inProgressDesc: 'proyek aktif'
  },
  projectValidationQueue: {
    title: 'Antrian Validasi Proyek',
    subtitle: 'Proyek yang menunggu persetujuan superuser sebelum dibuka untuk penawaran',
    noPending: 'Tidak ada proyek menunggu persetujuan',
    submittedOn: 'Dikirim',
    reject: 'Tolak',
    approve: 'Setujui',
    viewDetails: 'Lihat Detail',
    rejectModalTitle: 'Tolak Proyek',
    rejectModalHint:
      'Beri tahu klien alasan penolakan proyek ini agar mereka tahu apa yang harus diperbaiki.',
    rejectReasonLabel: 'Alasan penolakan',
    rejectReasonPlaceholder:
      'contoh: Dokumen legal belum lengkap, anggaran tidak realistis untuk lingkup ini...',
    rejectModalCancel: 'Batal',
    rejectModalConfirm: 'Konfirmasi Penolakan'
  },
  presetEditor: {
    title: 'Preset Formulir Singkat',
    subtitle:
      'Kartu yang tampil di landing page, dan nilai yang diisi otomatis ke formulir singkat',
    previewLabel: 'Pratinjau langsung',
    noPresets: 'Belum ada preset — tambahkan yang pertama',
    hidden: 'Disembunyikan',
    addPreset: 'Tambah preset',
    newPreset: 'Preset baru',
    editPreset: 'Ubah preset',
    edit: 'Ubah',
    delete: 'Hapus',
    moveUp: 'Naikkan',
    moveDown: 'Turunkan',
    slug: 'Slug',
    slugHint: 'Dipakai di URL, cth. /mulai-proyek?preset=apartment',
    buildingFunction: 'Terhubung ke kategori',
    projectScope: 'Lingkup proyek',
    subCategory: 'Sub-kategori',
    subCategoryNone: 'Tanpa sub-kategori',
    labelEn: 'Label kartu (EN)',
    labelId: 'Label kartu (ID)',
    eyebrowEn: 'Eyebrow kartu (EN)',
    eyebrowId: 'Eyebrow kartu (ID)',
    icon: 'Ikon',
    image: 'Gambar kartu',
    imageHint: 'Tampil di kartu "Tipe Proyek" landing page. JPG atau PNG, sebaiknya lanskap.',
    noImage: 'Belum ada gambar',
    removeImage: 'Hapus gambar',
    defaultsLabel: 'Nilai awal formulir',
    defaultsHint:
      'Terisi otomatis saat formulir dibuka dari kartu ini. Kosongkan bila tidak perlu.',
    defaultTitleEn: 'Judul default (EN)',
    defaultTitleId: 'Judul default (ID)',
    defaultLotSize: 'Luas lahan default (m²)',
    defaultDesignBudget: 'Budget desain default (IDR)',
    defaultDescriptionEn: 'Deskripsi default (EN)',
    defaultDescriptionId: 'Deskripsi default (ID)',
    visible: 'Tampil di landing page',
    cancel: 'Batal',
    save: 'Simpan',
    saving: 'Menyimpan...',
    deleteTitle: 'Hapus preset',
    deleteHint: 'Ini akan menghapus permanen kartu landing',
    loadError: 'Gagal memuat preset',
    saveError: 'Gagal menyimpan preset',
    deleteError: 'Gagal menghapus preset',
    reorderError: 'Gagal mengubah urutan preset'
  },
  landingEditor: {
    title: 'Editor Halaman Depan',
    subtitle: 'Kelola gambar hero carousel dan ulasan yang tampil di bawahnya',
    previewLabel: 'Pratinjau langsung',
    noSlides: 'Belum ada slide — tambahkan yang pertama',
    noQuote: 'Belum ada ulasan',
    hidden: 'Disembunyikan',
    addSlide: 'Tambah slide',
    newSlide: 'Slide baru',
    editSlide: 'Ubah slide',
    edit: 'Ubah',
    delete: 'Hapus',
    moveUp: 'Naikkan',
    moveDown: 'Turunkan',
    image: 'Gambar',
    chooseImage: 'Pilih gambar',
    removeImage: 'Hapus',
    imageHint: 'JPG, PNG, GIF atau WebP · maks 5MB',
    architectName: 'Nama arsitek / studio',
    rating: 'Rating (0–5)',
    quote: 'Kutipan ulasan',
    reviewerName: 'Nama pengulas',
    verified: 'Tampilkan lencana terverifikasi',
    visible: 'Tampil di halaman depan',
    cancel: 'Batal',
    save: 'Simpan',
    saving: 'Menyimpan...',
    deleteTitle: 'Hapus slide',
    deleteHint: 'Tindakan ini menghapus permanen gambar dan ulasan untuk'
  },
  superuserProjectDetail: {
    title: 'Detail Proyek',
    clientDetails: 'Detail Klien',
    clientDetailsHint:
      'Gunakan ini untuk menelepon klien dan memverifikasi proyek sebelum menyetujuinya.',
    name: 'Nama',
    email: 'Email',
    phone: 'Nomor Telepon',
    phoneVerified: 'Terverifikasi',
    phoneUnverified: 'Belum Terverifikasi',
    ktp: 'Nomor KTP',
    ktpVerified: 'Terverifikasi',
    ktpUnverified: 'Belum Terverifikasi',
    notProvided: 'Belum diisi',
    reject: 'Tolak',
    approve: 'Setujui',
    rejectModalTitle: 'Tolak Proyek',
    rejectModalHint:
      'Beri tahu klien alasan penolakan proyek ini agar mereka tahu apa yang harus diperbaiki.',
    rejectReasonLabel: 'Alasan penolakan',
    rejectReasonPlaceholder:
      'contoh: Dokumen legal belum lengkap, anggaran tidak realistis untuk lingkup ini...',
    rejectModalCancel: 'Batal',
    rejectModalConfirm: 'Konfirmasi Penolakan'
  },
  userManagement: {
    title: 'Manajemen Pengguna',
    subtitle: 'Lihat dan kelola pengguna platform',
    colUser: 'Pengguna',
    colRoles: 'Peran',
    colStatus: 'Status',
    colJoined: 'Bergabung',
    statusActive: 'Aktif',
    statusDeactivated: 'Dinonaktifkan',
    deactivate: 'Nonaktifkan',
    reactivate: 'Aktifkan Kembali',
    page: 'Halaman',
    of: 'dari',
    prev: 'Sebelumnya',
    next: 'Berikutnya',
    deactivateConfirm: 'Nonaktifkan pengguna ini? Mereka tidak akan dapat masuk.'
  },
  disputeManagement: {
    title: 'Manajemen Sengketa',
    subtitle: 'Selesaikan fase yang disengketakan antara klien dan arsitek',
    noDisputes: 'Tidak ada sengketa aktif',
    disputed: 'DISENGKETAKAN',
    maxRevisions: 'Maks revisi:',
    used: 'Digunakan:',
    resolutionNote: 'Catatan resolusi (opsional)',
    resolutionPlaceholder: 'Alasan keputusan Anda...',
    approveDeliverable: 'Setujui Deliverable',
    rejectToProgress: 'Tolak (Kembali ke IN_PROGRESS)',
    cancel: 'Batal',
    resolve: 'Selesaikan Sengketa'
  },
  negotiationDisputes: {
    title: 'Sengketa Negosiasi',
    subtitle:
      'Tinjau proyek yang jendela negosiasi 7 harinya berakhir tanpa konfirmasi kedua pihak',
    noDisputes: 'Tidak ada sengketa negosiasi',
    expired: 'BERAKHIR',
    client: 'Klien',
    architect: 'Arsitek',
    bidAmount: 'Nilai Penawaran',
    acceptedOn: 'Diterima pada',
    expiredOn: 'Berakhir pada',
    resolutionNote: 'Catatan resolusi (opsional)',
    resolutionPlaceholder: 'Konteks untuk keputusan Anda...',
    clientAbandoned: 'Klien Meninggalkan',
    architectAbandoned: 'Arsitek Meninggalkan',
    clientAbandonedHint:
      'Mengembalikan semua token penawaran di proyek ini, termasuk penawaran pemenang.',
    architectAbandonedHint:
      'Mengembalikan semua token penawaran kecuali penawaran pemenang, yang hangus.',
    cancel: 'Batal',
    resolve: 'Selesaikan'
  },
  allProjectsAdmin: {
    title: 'Semua Proyek',
    subtitle: 'Manajemen proyek seluruh platform',
    noProjects: 'Tidak ada proyek ditemukan',
    forceInProgress: 'Paksa IN_PROGRESS',
    forceCancel: 'Paksa Batalkan',
    forceCancelConfirm: 'Paksa batalkan proyek ini?',
    forceProgressConfirm: 'Paksa proyek ini ke IN_PROGRESS, melewati konfirmasi dua pihak?',
    filterAll: 'Semua',
    filterPendingApproval: 'Menunggu Persetujuan',
    filterOpen: 'Terbuka',
    filterNegotiation: 'Negosiasi',
    filterInProgress: 'Sedang Berlangsung',
    filterCompleted: 'Selesai',
    filterCancelled: 'Dibatalkan'
  },
  clientMessages: {
    title: 'Pesan',
    noConversations: 'Belum ada percakapan',
    projectChat: 'Obrolan Proyek',
    noMessagesYet: 'Belum ada pesan',
    selectConversation: 'Pilih percakapan',
    selectConversationHint: 'Pilih obrolan proyek dari daftar untuk mulai berkirim pesan.',
    typeMessage: 'Ketik pesan...'
  },
  projectStatus: {
    DRAFT: 'Draf',
    PENDING_APPROVAL: 'Menunggu Validasi',
    OPEN: 'Terbuka',
    BIDDING_CLOSED: 'Penawaran Ditutup',
    NEGOTIATION: 'Finalisasi',
    IN_PROGRESS: 'Sedang Berjalan',
    COMPLETED: 'Selesai',
    CANCELLED: 'Dibatalkan',
    REJECTED: 'Ditolak',
    CLOSED: 'Ditutup',
    AWARDED: 'Dimenangkan',
    PENDING: 'Menunggu Validasi',
    NEGOTIATION_EXPIRED: 'Finalisasi Kedaluwarsa',
    DELETED: 'Dihapus'
  },
  bidStatus: {
    DRAFT: 'Draft',
    PENDING: 'Menunggu',
    ACCEPTED: 'Diterima',
    REJECTED: 'Ditolak',
    WITHDRAWN: 'Ditarik'
  },
  iaiPicker: {
    examplesLabel: 'Contoh / Jenis Bangunan',
    legacyNote:
      'Entri lama ini tidak memiliki padanan dalam klasifikasi IAI. Entri tetap tersimpan di profil Anda, tetapi tidak dapat dipilih lagi.',
    selectedCount: 'terpilih',
    emptyHint: 'Buka sebuah kategori untuk memilih tipe bangunan yang Anda kerjakan.'
  },
  expertiseTagLabels: {
    Residential: 'Hunian',
    Commercial: 'Komersial',
    Renovation: 'Renovasi',
    'Sustainable Design': 'Desain Berkelanjutan',
    'Urban Planning': 'Perencanaan Kota',
    'Interior Design': 'Desain Interior',
    'Landscape Architecture': 'Arsitektur Lanskap',
    'Historic Preservation': 'Pelestarian Bersejarah',
    Institutional: 'Institusional',
    Industrial: 'Industri',
    'Mixed-Use': 'Fungsi Campuran',
    Hospitality: 'Hospitalitas'
  },
  degreeLevelLabels: {
    S1: 'S1 — Sarjana',
    S2: 'S2 — Magister',
    S3: 'S3 — Doktor'
  },
  brief: {
    nav: {
      howItWorks: 'Cara kerja',
      findArchitect: 'Cari arsitek',
      estimateCost: 'Estimasi biaya',
      login: 'Masuk',
      cta: 'Buat brief proyek'
    },
    steps: {
      lineup: {
        title: 'Layanan apa yang Anda butuhkan?',
        subtitle: 'Pilih satu atau beberapa layanan.'
      },
      quick: {
        title: 'Ceritakan brief proyek Kamu',
        subtitle: ''
      }
    },
    lineup: {
      design: {
        label: 'Desain arsitektur',
        desc: 'Konsep bangunan, tata ruang, gambar kerja, dan visualisasi desain.'
      },
      build: {
        label: 'Pembangunan',
        desc: 'Persiapan konstruksi, pelaksanaan pekerjaan, dan penyelesaian bangunan.'
      },
      craftsman: {
        label: 'Tukang dan Teknisi',
        desc: 'Untuk perbaikan atau pekerjaan berskala kecil.'
      },
      comingSoon: 'Segera tersedia',
      providerPrompt: 'Anda penyedia layanan?',
      providerCta: 'Gabung di sini'
    },
    privacy: {
      badge: 'Data Anda aman.',
      learnMore: 'Pelajari lebih lanjut',
      title: 'Bagaimana kami menjaga data Anda',
      close: 'Tutup',
      ok: 'Mengerti',
      points: [
        {
          title: 'Nomor telepon tidak ditampilkan',
          desc: 'Arsitek baru dapat menghubungi Anda setelah Anda menerima penawarannya.'
        },
        {
          title: 'Lokasi ditampilkan sebagai area',
          desc: 'Arsitek melihat kota atau kawasan proyek. Titik lokasi dan alamat lengkap dibagikan setelah kontrak disepakati.'
        },
        {
          title: 'Hanya untuk mitra terverifikasi',
          desc: 'Brief hanya dapat dibuka oleh arsitek yang sudah lolos verifikasi rumantra.'
        },
        {
          title: 'Tidak dijual ke pihak lain',
          desc: 'Data Anda dipakai untuk mencocokkan proyek dengan arsitek, tidak untuk iklan atau pihak ketiga.'
        }
      ]
    },
    form: {
      title: 'Judul Proyek',
      titlePlaceholder: 'cth. Rumah Keluarga Modern di Bandung',
      scope: 'Lingkup Proyek',
      scopeTips: {
        NEW_BUILD: 'Membangun bangunan baru di lahan kosong atau setelah bangunan lama dibongkar.',
        RENOVATION: 'Mengubah, memperbaiki, atau menambah luas bangunan yang sudah ada.',
        INTERIOR_FIT_OUT:
          'Menata ruang dalam bangunan yang sudah berdiri, seperti finishing, furnitur, dan pencahayaan.',
        RESTORATION:
          'Memulihkan bangunan lama atau bersejarah dengan tetap menjaga karakter aslinya.'
      },
      category: 'Kategori',
      categoryPlaceholder: 'Pilih kategori',
      subCategory: 'Sub-kategori',
      subCategoryPlaceholder: 'Pilih sub-kategori',
      subCategoryDisabled: 'Pilih kategori dulu',
      location: 'Lokasi',
      locationHint:
        'Cari alamatnya, lalu geser pin atau klik peta untuk menandai lokasi persisnya.',
      lotSize: 'Luas Lahan (m²)',
      lotSizePlaceholder: 'cth. 200',
      buildArea: 'Luas Bangunan (m²)',
      buildAreaPlaceholder: 'cth. 320',
      designFee: 'Budget Desain (Fee Arsitek)',
      designFeePlaceholder: 'cth. 150.000.000',
      designFeeHint:
        'Panduan IAI: tentukan fee desain yang wajar sesuai skala dan kompleksitas proyek Kamu.',
      openCalculator: 'Buka kalkulator',
      vision: 'Apa yang Kamu bayangkan?',
      visionPlaceholder: 'Jumlah ruangan, preferensi gaya, target waktu — apa pun akan membantu.',
      phone: 'Nomor Telepon',
      phonePlaceholder: 'cth. +62 812 3456 7890',
      phoneInvalid: 'Nomor telepon harus 10–16 digit.',
      requiredError: 'Wajib diisi.',
      start: 'Perkiraan Mulai',
      startImmediately: 'Secepatnya',
      startSpecific: 'Pada tanggal tertentu'
    },
    actions: {
      back: 'Kembali',
      saveAndContinue: 'Simpan dan lanjutkan',
      continue: 'Lanjutkan',
      submitting: 'Menyimpan…',
      needService: 'Pilih minimal satu layanan untuk melanjutkan',
      needFields: 'Belum diisi',
      submitError: 'Brief belum tersimpan. Coba lagi sebentar lagi.'
    },
    calculator: {
      title: 'Cari budget ideal Anda',
      subtitle: 'Klik perkiraan biaya desain untuk memakainya di form.',
      workLabel: 'Jenis pekerjaan',
      workBaru: 'Bangun baru',
      workRenovasi: 'Renovasi',
      budgetLabelBaru: 'Perkiraan budget pembangunan',
      budgetLabelRenovasi: 'Perkiraan budget renovasi',
      budgetHint:
        'Perkiraan biaya pembangunan saja, di luar harga tanah. Isi kolom kedua bila Anda punya kisaran.',
      minPlaceholder: 'Rp',
      maxPlaceholder: 'Rp (opsional)',
      until: 'sampai',
      eyebrow: 'Perkiraan biaya desain',
      use: 'Gunakan',
      useTitle: 'Gunakan di form',
      subtitle1: 'Untuk desain arsitektur sampai gambar kerja.',
      subtitle2: 'Tidak termasuk biaya pembangunan.',
      calcToggle: 'Asumsi perhitungan',
      calcBudget: 'Budget pembangunan',
      calcScope: 'Lingkup layanan',
      calcScopeValue: 'Desain arsitektur sampai gambar kerja',
      calcCategory: 'Kategori bangunan',
      renovationAdjustment: 'penyesuaian renovasi',
      calcMethod: 'Metode',
      calcMethodValue: 'Tabel imbalan jasa Pedoman IAI edisi 2007',
      fillBudget: 'Isi perkiraan budget untuk melihat estimasi.',
      invalidRange: 'Angka kedua sebaiknya lebih besar dari angka pertama.',
      disclaimer: 'Estimasi awal. Penawaran akhir mengikuti kebutuhan dan lingkup proyek.'
    },
    auth: {
      panelTitle: 'Satu akun untuk seluruh proyek Anda.',
      panelSubtitle: 'Brief yang sudah Anda isi tersimpan otomatis setelah masuk.',
      perks: [
        'Simpan brief dan lanjutkan kapan saja',
        'Terima penawaran dari arsitek terverifikasi',
        'Kelola kontrak, progres, dan pembayaran di satu tempat'
      ],
      tabLogin: 'Masuk',
      tabRegister: 'Daftar',
      loginTitle: 'Masuk ke rumantra',
      loginSubtitle: 'Gunakan akun yang sudah terdaftar.',
      registerTitle: 'Buat akun baru',
      registerSubtitle: 'Gratis. Hanya butuh satu menit.',
      google: 'Lanjutkan dengan Google',
      linkedin: 'Lanjutkan dengan LinkedIn',
      orEmail: 'atau dengan email',
      fullName: 'Nama lengkap',
      fullNamePlaceholder: 'cth. Budi Santoso',
      email: 'Email',
      emailPlaceholder: 'cth. budi@email.com',
      password: 'Kata sandi',
      passwordPlaceholder: 'Kata sandi Anda',
      newPasswordPlaceholder: 'Minimal 8 karakter',
      passwordHint:
        'Gunakan minimal 8 karakter dengan huruf besar, huruf kecil, angka, dan simbol.',
      strength: ['Terlalu lemah', 'Lemah', 'Cukup', 'Kuat', 'Sangat kuat'],
      loginCta: 'Masuk',
      registerCta: 'Buat akun',
      errEmail: 'Masukkan email yang valid.',
      errPassword: 'Masukkan kata sandi.',
      errName: 'Masukkan nama lengkap.',
      errWeakPassword:
        'Kata sandi minimal 8 karakter dengan huruf besar, huruf kecil, angka, dan simbol (@#$%^&+=!_-).',
      errTerms: 'Setujui Syarat dan Ketentuan untuk melanjutkan.',
      errLogin: 'Email atau kata sandi salah.',
      errRegister: 'Pendaftaran gagal. Coba lagi.',
      errSocial: 'Gagal terhubung. Coba lagi.',
      verifyTitle: 'Cek email Anda',
      verifyBody:
        'Kami mengirim tautan verifikasi ke {email}. Setelah akun aktif, masuk untuk melanjutkan brief Anda.',
      verifyCta: 'Kembali ke halaman masuk',
      doneTitle: 'Berhasil masuk',
      doneBody: 'Brief awal Anda sudah tersimpan di akun. Lanjutkan mengisi detail proyek.',
      doneCta: 'Lanjutkan',
      close: 'Tutup'
    }
  }
}
